/* eslint-disable no-self-compare */
import React from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, FieldArray, getIn, FormikHelpers } from 'formik';
import { AutoComplete, DatePicker } from 'formik-antd';
import { IProps } from './types';
import moment, { Moment } from 'moment-timezone';
import _ from 'lodash';
import { Occupation, OccupationContent, KycClaim, SysOption, KycOptionContent, EmailDomain, LifeContent, AgeData, SysOptionReq, MedicalContent, InsuredAmtOpt } from 'bff/models/info';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import memberProfileService from 'bff/services/memberProfileService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import AddressComponent from 'components/AddressComponent';
import { EvalInfoBodyType } from 'constants/enums/evalIfnoBodyType.enum';
import { ExpanBodyContent, ExpanBodyBaseContent, ExpanFooterContent, EvalExpans } from 'constants/models/evalExpans';
import service from 'bff/services/travelProductService';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import Fold from 'components/Fold';
import { CodeId } from 'constants/enums/codeId.enum';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import sweetAlertService from 'utils/sweetAlertService';
import InsuredPersonMatch from 'constants/models/insuredPersonMatch';
import { InsCount } from 'constants/enums/insCount.enum';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import { InsureSubject } from 'constants/enums/insureSubject.enum';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { DATAReqContent, PolicyFeeReq, CheckApplyTypeReq, InsuredDataContent, RuleCheckReqContent, InsuredRuleCheckContent, RuleValidReq } from 'bff/models/product';
import { ApplyType } from 'constants/enums/applyType.enum';
import { withRouter } from 'react-router-dom';
import { ApplyNoType } from 'constants/enums/applyNoType.enum';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { ICalcFormValue } from 'constants/models/components/insurProcess/insureProcessCalc';
import { IFill2ndFormValue, InsuredState, IFill2ndState, KYC_INIT_CONDITION, KycInfo } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { TravelWarningExpandData, IFill1stFormValue } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { MemberProfile } from 'bff/models/member';
import InputWithRegex from 'components/InputWithRegex';
import { GeoAreaId } from 'constants/enums/geoAreaId.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setInfoModalVisibleAction, setRuleValidErrorModalVisible, setMemberInfoErrorModalVisible } from 'redux/actions/modal.action';
import { mobileRegex, emailRegex } from 'utils/commonValidations';
import FormikFocusError from 'components/FormikFocusError';
import { NationalType } from 'constants/enums/nationalType.enum';
import MemberInfoErrorModal from 'components/MemberInfoErrorModal';
import { InsType } from 'constants/enums/insType.enum';
import { InfoCheckmailandmobileReq } from 'bff/models/info/infoCheckmailandmobile';
import { ActualAgeData } from 'bff/models/info/actualAge';

const initInsured: InsuredState = {
  INSURED_RELATION: '',
  INSURED_RELATION_NAME: '',
  INSURED_NAME: '',
  INSURED_ID: '',
  INSURED_ID_ERROR: false,
  INSURED_ID_VALID: true,
  INSURED_BIRTHDAY: '',
  INSURED_BIRTHDAY_ERROR: false,
  INSURED_CONTRACT_AGE: 0,
  INSURED_IS_UNDER15: false,
  INSURED_MOBILE: '',
  INSURED_EMAIL_ADDR: '',
  INSURED_AMT: '',
  INSURED_AGE_LIMIT_AMT: 0,
  INSURED_AMT_NAME: '',
  INSURED_AMT_OPTS: {},
  INSURED_MFUNERAL: 0,
  INSURED_MEDICAL: '',
  INSURED_MEDICAL_NAME: '',
  INSURED_MEDICAL_VALUE: '',
  INSURED_CALC: ''
};

const initialVal: IFill2ndFormValue = {
  NATIONALITY_TYPE: 'N', // 預設本國人
  INSURE_SUBJECT: '',
  MEMBER_ID: '',
  NAME: '',
  BIRTHDAY: '',
  EMAIL_ADDR: '',
  POST_CODE: '',
  CITY_ID: '',
  CITY_NAME: '',
  AREA_ID: '',
  AREA_NAME: '',
  ADDRESS: '',
  MOBILE: '09',
  OCCUPATION_ID: '',
  OCCUPATION_DOMAIN_ID: '',
  OCCUPATION_DOMAIN_ID_NAME: '',
  OCCUPATION_ID_NAME: '',
  OCCUPATION_DESC: '',
  OCCUPATION_DESC_NAME: '',
  KYCINFOS: [
    {
      KYC_ID: '',
      KYC_ANSWER: '',
      KYC_ANSWER_TEXT: '',
      KYC_OTHER: ''
    }
  ],
  INSUREDS: [
    {
      ...initInsured,
      INSURED_RELATION: InsuredRelation.Self,
      INSURED_RELATION_NAME: '本人'
    }
  ],
  DELIVERY: PolicyDelivery.Electric
};

let initialValues: IFill2ndFormValue = initialVal;

// KYC 預設相依條件
const defaultKycCond: KYC_INIT_CONDITION = {
  INS_COUNT: InsCount.One,
  INSURED_SUBJECT: '',
  OVER15_COUNT: '',
  UNDER15_COUNT: ''
};

/** 下拉選單的預設項目文字 */
const selectOptDefaultText = '請選擇';
// 判斷是否顯示會員資料錯誤 Modal
let showMemberInfoErrorModal = false;

class InsureProcessFill2nd extends React.PureComponent<IProps, IFill2ndState> {
    private policyholderInfoRef = React.createRef() as React.RefObject<HTMLDivElement>;
    private programDetailsRef = React.createRef() as React.RefObject<HTMLDivElement>;
    private lastInsuredRef = React.createRef() as React.RefObject<HTMLDivElement>;
    // private validBirthDay = moment().subtract(20, 'years'); // 合理範圍的生日日期
    private formikRef: any = React.createRef();

    // Validation Schema: 移入類別內，以取得 state 資料執行檢核
    private validationSchema = Yup.object().shape({
      NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
      MEMBER_ID: Yup.string().required('此為必填欄位').length(10, '帳號長度為 10 字元'),
      NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '姓名長度不可超過 200 字元')
        // .matches(/^[^A-Za-z0-9\s`~!@#$%^&*()_\\\-+=<>?:"{}|,./;'\[\]·~！@#￥%……&*（）——+={}|《》？：“”【】、；‘'，。、]*$/, '請勿輸入英文、數字、符號、空格'),
        // .test('contain num', '姓名格式不符', (val: string) => {
        //   if (val) {
        //     return !(/[\d]+/.test(val));
        //   }
        //   return true;
        // }),
        .test('check name', '姓名格式錯誤', (val: string) => {
          if (!val) return false;
          if (/[0-9]/.test(val)) return false;

          const contentOnly = val.replace(/[\s`~!@#$%^&*()_\\\-+=<>?:"{}|,./;'[\]·~！@#￥%……&*（）——+={}|《》？·‧ ：“”【】、；‘'，。、ˇˋˊ˙･]/g, '');
          if (contentOnly.length === 0) return false;

          return true;
        }),
      BIRTHDAY: Yup.string().required('此為必填欄位').nullable(),
      EMAIL_ADDR: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(this.props.UICode, CodeId.W087), (val: string) => {
        if (val && emailRegex.test(val)) {
          const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
          const isBlocked = this.state.blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
          if (isBlocked) return false;
        }
        return true;
      }),
      POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
      CITY_ID: Yup.string().required('此為必填欄位'),
      AREA_ID: Yup.string().required('此為必填欄位'),
      ADDRESS: Yup.string().required('此為必填欄位').max(70, '詳細地址長度不可超過 70 字元').matches(/^[\u4e00-\u9fa5\d]*$/, '限輸入中文、數字，請勿輸入信箱、符號、空格等'),
      MOBILE: Yup.string().required('此為必填欄位').length(10, '手機號碼長度為 10 字元').test('mobile format', '手機格式不符', (val: string) => {
        if (val) {
          return mobileRegex.test(val);
        }
        return true;
      }),
      OCCUPATION_DOMAIN_ID: Yup.string().required('此為必填欄位').nullable(),
      OCCUPATION_ID: Yup.string().when('OCCUPATION_DOMAIN_ID', (occupationId: OccupationIdType, schema: any) => {
        return occupationId && occupationId === OccupationIdType.Special ? schema.required('職業項目為必填欄位') : schema;
      }).nullable(),
      INSUREDS: Yup.array().of(
        Yup.object().shape({
          INSURED_RELATION: Yup.string().required('此為必填欄位'),
          INSURED_NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '最大長度為 200 字元')
            // .matches(/^[^A-Za-z0-9\s`~!@#$%^&*()_\\\-+=<>?:"{}|,./;'\[\]·~！@#￥%……&*（）——+={}|《》？：“”【】、；‘'，。、]*$/, '請勿輸入英文、數字、符號、空格'),
            // .test('contain num', '姓名格式不符', (val: string) => {
            //   if (val) {
            //     return !(/[\d]+/.test(val));
            //   }
            //   return true;
            // }),
            .test('check name', '姓名格式錯誤', (val: string) => {
              if (!val) return false;
              if (/[0-9]/.test(val)) return false;

              const contentOnly = val.replace(/[\s`~!@#$%^&*()_\\\-+=<>?:"{}|,./;'[\]·~！@#￥%……&*（）——+={}|《》？·‧ ：“”【】、；‘'，。、ˇˋˊ˙･]/g, '');
              if (contentOnly.length === 0) return false;

              return true;
            }),
          INSURED_ID: Yup.string().required('此為必填欄位').length(10, '帳號長度為 10 字元'),
          INSURED_BIRTHDAY: Yup.string().nullable().required('此為必填欄位'),
          INSURED_AMT: Yup.string().required('此為必填欄位'),
          INSURED_MFUNERAL: Yup.number().when('INSURED_BIRTHDAY', {
            is: (birthday) => {
              return moment().diff(birthday, 'days') < 365 * 15;
            },
            then: Yup.number().min(1, '此為必填欄位'),
            otherwise: Yup.number()
          })
        })
      ),
      DELIVERY: Yup.string().required('此為必填欄位'),
      KYCINFOS: Yup.array().of(
        Yup.object().shape({
          KYC_ANSWER: Yup.string().required('此為必填欄位'),
          KYC_OTHER: Yup.string().when('KYC_ANSWER', (answer: string, schema: any) => {
            return answer && answer === '99' ? schema.required('此為必填欄位') : schema;
          })
        })
      )
    });

    readonly state: IFill2ndState = {
      programSummaryVisible: false,
      programSummaryDetailsOpen: false,
      programDetailsOpen: false,
      occupationId: '',
      prodId: '',
      insCount: '',
      hasMemberId: false,
      isAgeLimit: false,
      isInitFirstInsured: false,
      policyDeliverySysOpts: new Array(0),
      relationSysOpts: new Array(0),
      nationalitySysOpts: new Array(0),
      memberIdErrMsg: '',
      birthdayErrMsg: '',
      insuredsBirthdayErrMsg: '',
      prodIdError: false,
      detailFoldsOpen: new Array(0),
      blockDomains: [],
      hidePolicyID: false,
      notices: [[]]
    }

    componentDidMount = async () => {
      commonService.scrollToTop();
      this.addWindowScrollEvent();

      // 判斷是否登入
      const loginInfo = storageService.getItem(storageKeys.LoginInfo);
      if (!loginInfo) {
        // sweetAlertService.modal({
        //   html: `${commonService.getCodeMsg(this.props.UICode, CodeId.W007)} <br /> ${commonService.getCodeMsg(this.props.UICode, CodeId.W009)}`,
        //   showCancelButton: true,
        //   showCloseButton: true
        // }).then(async res => {
        //   if (res.value) {
        //     this.props.onTempData();

        //     const path = {
        //       pathname: RouterSettings.Login,
        //       state: { originUrl: RouterSettings.InsureProcess.Travel }
        //     };

        //     this.props.history.push(path);
        //   }
        //   if (res.dismiss) {
        //     await this.handleFetchSysOpts();
        //     await this.handleInitState();
        //   }
        // });
        await this.handleFetchSysOpts();
        await this.handleInitState();
      } else {
        await this.handleFetchSysOpts();
        await this.handleInitState();
      }
      // this.props.onTempData(this.formikRef.current.values, this.state);
    };

    // #region 清除與要保人關係欄位資料相關方法

    /**
     * @description 當投保人數一人，投保對象為親屬，清除被保險人卡片關係為本人的與要保人關係欄位資料
    */
    handleRemoveSelf = () => {
      const removeSelf = this.handleIsRemoveSelf();
      if (this.formikRef && this.formikRef.current && removeSelf) {
        let insureds = this.formikRef.current.values.INSUREDS;
        insureds = _.map(insureds, (insured: InsuredState) => {
          return {
            ...insured,
            INSURED_RELATION: insured.INSURED_RELATION === InsuredRelation.Self ? '' : insured.INSURED_RELATION,
            INSURED_RELATION_NAME: insured.INSURED_RELATION === InsuredRelation.Self ? '' : insured.INSURED_RELATION_NAME
          };
        });
        this.formikRef.current.setFieldValue('INSUREDS', insureds);
      }
    }

    /**
     * @description 判斷是否為投保人數 一 人，投保對象為親屬
    */
    handleIsRemoveSelf = () => {
      const removeSelf = this.state.insCount === InsCount.One &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives;

      return removeSelf;
    }

    /**
     * @description 判斷是否為投保人數 多人，投保對象為親屬，移除兄弟姊妹選項
    */
    handleIsRemoveBrother = () => {
      const removeBrother = this.state.insCount === InsCount.MORE &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives;

      return removeBrother;
    }

    // #endregion

    componentDidUpdate () {
      /** 抓取電子郵件欄位，限制輸入長度用 */
      const emailInput = document.getElementById('email') as HTMLInputElement;
      if (emailInput) {
        emailInput.setAttribute('maxlength', '50');
        emailInput.setAttribute('autocomplete', 'off');
      }

      const hasInsureds = this.formikRef &&
            this.formikRef.current &&
            this.formikRef.current.values &&
            this.formikRef.current.values.INSUREDS &&
            this.formikRef.current.values.INSUREDS.length > 0;

      if (hasInsureds) {
        _.forEach(this.formikRef.current.values.INSUREDS, (insured: InsuredState, index: number) => {
          // INSUREDS[0].INSURED_EMAIL_ADDR
          const emailInput = document.getElementById(`INSUREDS[${index}].INSURED_EMAIL_ADDR`) as HTMLInputElement;
          if (emailInput) {
            emailInput.setAttribute('maxlength', '50');
            emailInput.setAttribute('autocomplete', 'off');
          }
        });
      }

      this.handleRemoveSelf();
    }

    componentWillUnmount () {
      if (!this.formikRef || !this.formikRef.current) return;

      const formVal = this.formikRef.current.values;

      this.props.onUnmount(formVal, this.state);

      initialValues = {
        ...initialVal
      };

      this.removeWindowScrollEvent();
    }

    // #region 頁面初始相關方法
    /**
      * @description 初始化 State 資料
     */
    handleInitState = async () => {
      // 判斷是否已登入，並取得會員資料
      const memberId = storageService.getItem(storageKeys.MemberId);
      let memberInfo: any;
      if (memberId) {
        memberInfo = await memberProfileService.fetchMemberProfile(memberId) as MemberProfile;

        if (!memberInfo) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: '無法取得會員資訊'
          });

          return;
        }
      }

      // 取得試算頁資料
      const tempCalcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue;

      // 取得試算頁保險人數選項資料
      const insCount = tempCalcFormVal?.INS_COUNT as InsCount;
      const prodId = tempCalcFormVal?.PROD_ID;

      // 取得投保對象資料
      const PClass = commonService.getSubjectPClass(prodId, insCount);
      const insureSubject = PClass && await service.fetchSubjectCode(PClass).then(res => {
        return _.find(res, (sysOption: SysOption, index: number) => {
          return sysOption.PARAM_VALUE === tempCalcFormVal?.INSURED_SUBJECT;
        });
      });
      // 追加 KYC 第一題之推論預設答案
      initialValues = {
        ...initialValues,
        ...this.props.tempFill2nd.tempFill2ndFormVal,
        KYCINFOS: this.handleGetKycInfos(this.combineKycCondition()),
        INSURE_SUBJECT: insureSubject?.PARAM_VALUE || ''
      };

      // 是否預設被保人區塊第一人
      const isInitFirstInsured = !(insCount === InsCount.One && insureSubject?.PARAM_VALUE === InsureSubject.Relatives);

      // 判斷是否有暫存資料
      const hasTemp = this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndFormVal && this.props.tempFill2nd.tempFill2ndState;

      /**
         * 依不同情況執行不同方法
         * 1. 有暫存資料、登入者 ID、尚未帶入會員資料於要本人
         * 2. 有暫存資料、無登入者 ID
         * 3. 無暫存資料
        */
      let calcRes: any;
      let prodIdError = false;
      if (hasTemp && memberId && !this.props.tempFill2nd.tempFill2ndState?.hasMemberId) {
        // console.log("🚀 ~ 情況 1. 有暫存資料、登入者 ID、尚未帶入會員資料於要保人 ~ handleFirstCondition")
        // 情況 1. 有暫存資料、登入者 ID、尚未帶入會員資料於要保人
        calcRes = await this.handleFirstCondition(memberInfo, insureSubject, insCount, isInitFirstInsured);
        showMemberInfoErrorModal = true;
      } else if (hasTemp) {
        // console.log("🚀 ~ 情況 2. 有暫存資料、無登入者 ID ~ handleSecondCondition")
        // 情況 2. 有暫存資料、無登入者 ID
        calcRes = await this.handleSecondCondition(insureSubject);
        prodIdError = this.handleCheckProdId(this.props.tempFill2nd.tempFill2ndFormVal?.NATIONALITY_TYPE || '');
        showMemberInfoErrorModal = false;
      } else {
        // 情況 3. 無暫存資料
        // console.log("🚀 ~ 情況 3. 無暫存資料 ~ handleThirdCondition")
        calcRes = await this.handleThirdCondition(memberInfo, insureSubject, isInitFirstInsured);
        showMemberInfoErrorModal = true;
      }

      if (showMemberInfoErrorModal && commonService.checkMemberInfoError(memberInfo)) {
        this.props.setMemberInfoErrorModalVisible(true, '', commonService.getCodeMsg(this.props.UICode, CodeId.W066), ['MOBILE', 'EMAIL_ADDR']);
      }

      // 取得網域黑名單
      let blockDomains: EmailDomain[] = [];
      const response = await apiCommonService.fetchBlockDomains();
      if (response) blockDomains = response;

      const initState = {
        ...this.props.tempFill2nd.tempFill2ndState as IFill2ndState,
        insureSubject: insureSubject,
        hasMemberId: memberId,
        insCount: insCount,
        prodId: tempCalcFormVal?.PROD_ID as string,
        planData: calcRes ? calcRes.PlanData : this.props.tempCalc.planData,
        isInitFirstInsured: isInitFirstInsured,
        occupationId: calcRes ? calcRes.OccupationId : '',
        isAgeLimit: calcRes ? calcRes.IsAgeLimit : false,
        prodIdError: prodIdError,
        blockDomains
      };

      // console.log("🚀 ~ InsureProcessFill2nd ~ handleInitState= ~ initState:", initState)
      this.setState(initState);
      this.handleCheckAllInsuredBirthdayThroughInsuredRelation(initialValues);
    }

    /**
     * @description 有暫存資料、登入者 ID、無套入過登入者資料
    */
    handleFirstCondition = async (
      memberInfo: any, insureSubject: any, insCount: any, isInitFirstInsured: any
    ) => {
      const isAgeLimit = await this.handleIsAgeLimit(memberInfo.BIRTHDAY, insureSubject);
      // 設定登入者的職業選項，並取得職業 Id，並帶入登入者資訊
      const occupationId = this.handleSetOccupationAndMemberInfo(memberInfo);

      const { INSURED_SUBJECT, OVER15_COUNT } = this.props.tempCalcFormVal;
      const isSelfSubject = INSURED_SUBJECT === InsureSubject.Self;
      const hasOver15 = (+OVER15_COUNT) > 0;

      const tempFill2FormVal = { ...this.props.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
      let insureds = [
        ...tempFill2FormVal.INSUREDS.map((insured: InsuredState) => ({
          ...insured,
          INSURED_BIRTHDAY: insured.INSURED_BIRTHDAY ? moment(insured.INSURED_BIRTHDAY).format() : ''
        }))
      ];
      const firstInsured = insureds[0];
      // 第一被保人是否需覆蓋登入者資訊，幫自己、5人以上需覆蓋，多人且對象為親屬時，判斷欄位是否有填寫了，有就不覆蓋
      const setFistMember = insureSubject?.PARAM_VALUE !== InsureSubject.Relatives ||
            (insCount === InsCount.MORE && insureSubject?.PARAM_VALUE === InsureSubject.Relatives &&
                !(firstInsured.INSURED_ID || firstInsured.INSURED_NAME || firstInsured.INSURED_BIRTHDAY || firstInsured.INSURED_CALC || firstInsured.INSURED_AMT || firstInsured.INSURED_MOBILE || firstInsured.INSURED_EMAIL_ADDR));

      // 預設被保人區塊第一人
      if (isInitFirstInsured && this.formikRef && this.formikRef.current && setFistMember) {
        const firstInsured: InsuredState = { ...insureds.splice(0, 1)[0] };
        firstInsured.INSURED_RELATION = InsuredRelation.Self;
        firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Self);
        firstInsured.INSURED_NAME = memberInfo.NAME;
        firstInsured.INSURED_ID = memberInfo.MEMBER_ID;
        firstInsured.INSURED_BIRTHDAY = memberInfo.BIRTHDAY;
        firstInsured.INSURED_MOBILE = memberInfo.MOBILE;
        firstInsured.INSURED_EMAIL_ADDR = memberInfo.EMAIL_ADDR;
        // 針對第一被保人，僅校正「一人投保」下，選擇「幫自己或未滿7歲子女保」的狀況
        if (isSelfSubject && insCount === InsCount.One) {
          if (!hasOver15) {
            firstInsured.INSURED_RELATION = InsuredRelation.Child;
            firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Child);
            firstInsured.INSURED_NAME = '';
            firstInsured.INSURED_ID = '';
            firstInsured.INSURED_BIRTHDAY = '';
            firstInsured.INSURED_MOBILE = '';
            firstInsured.INSURED_EMAIL_ADDR = '';
          }
        }
        insureds = [firstInsured, ...insureds];
      }

      // 判斷是否包含本人項目，帶入會員資料
      const selfIndex = this.handleGetSelfIndex(tempFill2FormVal);
      if (selfIndex !== -1) {
        const selfInsured: InsuredState = { ...insureds.splice(selfIndex, 1)[0] };
        selfInsured.INSURED_NAME = memberInfo.NAME;
        selfInsured.INSURED_ID = memberInfo.MEMBER_ID;
        selfInsured.INSURED_BIRTHDAY = memberInfo.BIRTHDAY;
        selfInsured.INSURED_MOBILE = memberInfo.MOBILE;
        selfInsured.INSURED_EMAIL_ADDR = memberInfo.EMAIL_ADDR;
        insureds.splice(selfIndex, 0, selfInsured);
      }

      let planData: any = { ...this.props.tempCalc.planData };

      // 執行保費計算
      const calcRes = await this.handleInsuredsCalc(planData, insureds);
      planData = calcRes.PlanData;
      initialValues = {
        ...initialValues,
        INSUREDS: [...calcRes.Insureds]
      };

      return { PlanData: planData, IsAgeLimit: isAgeLimit, OccupationId: occupationId };
    }

    /**
     * @description 有暫存資料
    */
    handleSecondCondition = async (insureSubject: any) => {
      const occupationId = this.props.tempFill2nd?.tempFill2ndState?.occupationId as string;
      const tempFill2FormVal = { ...this.props.tempFill2nd.tempFill2ndFormVal } as IFill2ndFormValue;
      const isAgeLimit = await this.handleIsAgeLimit(tempFill2FormVal.BIRTHDAY, insureSubject);
      const insureds = [
        ...tempFill2FormVal.INSUREDS.map((insured: InsuredState) => ({
          ...insured,
          INSURED_BIRTHDAY: insured.INSURED_BIRTHDAY ? moment(insured.INSURED_BIRTHDAY).format() : ''
        }))
      ];

      // const { INSURED_SUBJECT, OVER15_COUNT, UNDER15_AMOUNT, INS_COUNT } = this.props.tempCalcFormVal;
      // const hasOver15 = (+OVER15_COUNT) > 0;

      // 取得暫存的被保險人
      // let insureds = [...tempFill2FormVal.INSUREDS];
      // 與暫存資料衝突
      // // 預設被保人區塊第一人
      // // 設定第一張被保人卡片為本人
      // const firstInsured: InsuredState = { ...insureds.splice(0, 1)[0] };
      // firstInsured.INSURED_RELATION = InsuredRelation.Self;
      // firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Self);
      // firstInsured.INSURED_NAME = tempFill2FormVal.NAME;
      // firstInsured.INSURED_ID = tempFill2FormVal.MEMBER_ID;
      // firstInsured.INSURED_BIRTHDAY = tempFill2FormVal.BIRTHDAY;
      // firstInsured.INSURED_MOBILE = tempFill2FormVal.MOBILE;
      // firstInsured.INSURED_EMAIL_ADDR = tempFill2FormVal.EMAIL_ADDR;
      // // 針對第一被保人
      // if (INS_COUNT === InsCount.One) {
      //   if ((INSURED_SUBJECT === InsureSubject.Self || INSURED_SUBJECT === InsureSubject.Relatives) && !hasOver15) {
      //     firstInsured.INSURED_RELATION = InsuredRelation.Child;
      //     firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Child);
      //     firstInsured.INSURED_NAME = '';
      //     firstInsured.INSURED_ID = '';
      //     firstInsured.INSURED_BIRTHDAY = '';
      //     firstInsured.INSURED_MOBILE = '';
      //     firstInsured.INSURED_EMAIL_ADDR = '';
      //   }
      //   if (INSURED_SUBJECT === InsureSubject.Relatives && hasOver15) {
      //     firstInsured.INSURED_RELATION = InsuredRelation.Spouse;
      //     firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Spouse);
      //   }
      // }
      // if (INS_COUNT === InsCount.MORE && INSURED_SUBJECT === InsureSubject.Self && +OVER15_COUNT === 0 && +UNDER15_AMOUNT >= 1) {
      //   firstInsured.INSURED_RELATION = InsuredRelation.Child;
      //   firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Child);
      // }
      // insureds = [firstInsured, ...insureds];

      let planData: any = { ...this.props.tempCalc.planData };

      // 執行保費計算
      const calcRes = await this.handleInsuredsCalc(planData, insureds);
      planData = calcRes.PlanData;
      initialValues = {
        ...tempFill2FormVal,
        ...initialValues,
        INSUREDS: [...calcRes.Insureds],
        INSURE_SUBJECT: insureSubject?.PARAM_VALUE || ''
      };
      return { PlanData: planData, IsAgeLimit: isAgeLimit, OccupationId: occupationId };
    }

    /**
     * @description 無暫存資料
    */
    handleThirdCondition = async (memberInfo: any, insureSubject: any, isInitFirstInsured: any) => {
      const { INSURED_SUBJECT, OVER15_COUNT, UNDER15_AMOUNT, UNDER15_COUNT, INS_COUNT } = this.props.tempCalcFormVal;
      const hasOver15 = (+OVER15_COUNT) > 0;
      const hasUnder15 = (+UNDER15_COUNT) > 0;

      // 預設被保人區塊第一人
      const firstInsured: any = {};
      firstInsured.INSURED_RELATION = InsuredRelation.Self;
      firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Self);
      if (INS_COUNT === InsCount.One) {
        if ((INSURED_SUBJECT === InsureSubject.Self || INSURED_SUBJECT === InsureSubject.Relatives) && !hasOver15) {
          firstInsured.INSURED_RELATION = InsuredRelation.Child;
          firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Child);
        }
        if (INSURED_SUBJECT === InsureSubject.Relatives && hasOver15) {
          firstInsured.INSURED_RELATION = InsuredRelation.Spouse;
          firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Spouse);
        }
      }
      if (INS_COUNT === InsCount.MORE && INSURED_SUBJECT === InsureSubject.Self && +OVER15_COUNT === 0 && +UNDER15_AMOUNT >= 1) {
        firstInsured.INSURED_RELATION = InsuredRelation.Child;
        firstInsured.INSURED_RELATION_NAME = this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Child);
      }

      initialValues = {
        ...initialValues,
        INSUREDS: [{
          ...initialValues.INSUREDS[0],
          ...firstInsured
        }]
      };

      if (!memberInfo) return;

      // 於登入後使用者選 「一人投保」下，選擇「幫自己或未滿7歲子女保」且被保人僅子女第一次進到此頁，要保人僅帶入會員資料但不試算
      if (INSURED_SUBJECT === InsureSubject.Self && INS_COUNT === InsCount.One && !hasOver15) {
        await this.handleIsAgeLimit(memberInfo.BIRTHDAY, insureSubject);
        this.handleSetOccupationAndMemberInfo(memberInfo);
        return;
      }

      // 多人投保如果只有小於15歲，被保險人關係預設為子女
      if (!hasOver15 && hasUnder15) {
        await this.handleIsAgeLimit(memberInfo.BIRTHDAY, insureSubject);
        this.handleSetOccupationAndMemberInfo(memberInfo);
        return;
      }

      const isAgeLimit = await this.handleIsAgeLimit(memberInfo.BIRTHDAY, insureSubject);

      // 設定登入者的職業選項，並取得職業 Id，並帶入登入者資訊
      const occupationId = this.handleSetOccupationAndMemberInfo(memberInfo);

      let planData: any = { ...this.props.tempCalc.planData };

      // 預設被保人區塊第一人
      if (isInitFirstInsured && this.formikRef && this.formikRef.current) {
        const insureds = new Array(0);

        // 執行保費計算
        planData = await this.handleReCalc(insureds, memberInfo, planData);
        initialValues = {
          ...initialValues,
          INSUREDS: [...insureds]
        };
      }

      return { PlanData: planData, IsAgeLimit: isAgeLimit, OccupationId: occupationId };
    }

    /**
     * @description 重新試算被保險人投保金額
     * @param planData 投保計畫資料
     * @param insureds 被保人資料
     */
    handleInsuredsCalc = async (planData: any, insureds: InsuredState[]) => {
      // 進行保費試算，取得更新投保金額後的被保險人資料
      const newInsureds = new Array(0);
      for (let i = 0; i < insureds.length; i += 1) {
        planData = await this.handleReCalc(newInsureds, insureds[i], planData, i);
      }
      return { PlanData: planData, Insureds: newInsureds };
    }

    /**
     * @description 重新試算投保金額
     */
    handleReCalc = async (
      saveArray: InsuredState[], memberInfo: any, planData: any, index = 0) => {
      const birthdayVal = memberInfo.BIRTHDAY || memberInfo.INSURED_BIRTHDAY;
      // 取得試算頁資料
      const tempCalcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue;
      if (!tempCalcFormVal || !birthdayVal) {
        saveArray.push({
          INSURED_RELATION: memberInfo.INSURED_RELATION,
          INSURED_RELATION_NAME: memberInfo.INSURED_RELATION_NAME,
          INSURED_NAME: memberInfo.NAME || memberInfo.INSURED_NAME,
          INSURED_ID: memberInfo.MEMBER_ID || memberInfo.INSURED_ID,
          INSURED_ID_VALID: true,
          INSURED_BIRTHDAY: birthdayVal,
          INSURED_ID_ERROR: memberInfo.INSURED_ID_ERROR || false,
          INSURED_BIRTHDAY_ERROR: memberInfo.INSURED_BIRTHDAY_ERROR || false,
          INSURED_CONTRACT_AGE: 0,
          INSURED_IS_UNDER15: false,
          INSURED_MOBILE: memberInfo.MOBILE || memberInfo.INSURED_MOBILE,
          INSURED_EMAIL_ADDR: memberInfo.EMAIL_ADDR || memberInfo.INSURED_EMAIL_ADDR,
          INSURED_AGE_LIMIT_AMT: 0,
          INSURED_AMT_OPTS: null,
          INSURED_AMT: '',
          INSURED_AMT_NAME: '',
          //* /policy/rule/validate 被保險人資料
          INSURED_MFUNERAL: 0,
          INSURED_MEDICAL: '',
          INSURED_MEDICAL_VALUE: '',
          INSURED_MEDICAL_NAME: '',
          INSURED_CALC: ''
        });
        return planData;
      }

      // 格式化生日
      const birthday = moment(birthdayVal).format('YYYYMMDD');

      // 取得投保方案起始日
      const contractDate = moment(tempCalcFormVal.START_DATE).format('YYYYMMDD');

      const insuredAge = await this.handleGetInsuredAge(birthdayVal);

      let insuredAmtOptRes: InsuredAmtOpt | undefined;

      if (this.hasAgeLimitAmt(insuredAge)) {
        // 取得失能保額清單值
        insuredAmtOptRes = await service.fetchInsuredAmtOpt(
          planData.INS_TYPE_ID, planData.PROD_ID, planData.HEADER.PLAN_ID, birthday, contractDate);
      }
      // 有在選項內的保額，若無可選檔次則為 undefined
      let insuredAmt: LifeContent | undefined;
      let medicalAmtText = '';
      let medicalAmtVal = '';

      // insuredAmt = memberInfo.INSURED_AMT ? +memberInfo.INSURED_AMT : 0;
      // insuredAmt = (insuredAmtOptRes?.OPTIONS.LIFE.filter((item:any) => +item.VALUE === +this.props.tempCalcFormVal.OVER15_AMOUNT).length ?? 0) > 0 ? +this.props.tempCalcFormVal.OVER15_AMOUNT : 0;
      const { INSURED_SUBJECT, OVER15_COUNT, INS_COUNT, OVER15_AMOUNT, UNDER15_AMOUNT } = tempCalcFormVal;
      const isSelfSubject = INSURED_SUBJECT === InsureSubject.Self;
      const hasOver15 = (+OVER15_COUNT) > 0;
      if (this.props.tempFill2nd.tempFill2ndFormVal) {
        const { INSUREDS } = this.props.tempFill2nd.tempFill2ndFormVal;
        const tempInsuredAmt: string = INSUREDS[index].INSURED_AMT ?? '0';
        // 從緩存資料取保額
        insuredAmt = insuredAmtOptRes?.OPTIONS.LIFE.find((item:any) => +item.VALUE === +tempInsuredAmt);
        // 針對第一被保人(index 為 0)，僅校正「一人投保」下，選擇「幫自己或未滿7歲子女保」的保額
        if (isSelfSubject && INS_COUNT === InsCount.One && index === 0) {
          if (hasOver15) {
            // 於保額不一致的狀況下更換保額
            if (OVER15_AMOUNT !== tempInsuredAmt) {
              insuredAmt = insuredAmtOptRes?.OPTIONS.LIFE.find((item:any) => +item.VALUE === parseInt(OVER15_AMOUNT));
            }
          } else {
            // 於保額不一致的狀況下更換保額
            if (UNDER15_AMOUNT !== tempInsuredAmt) {
              insuredAmt = insuredAmtOptRes?.OPTIONS.LIFE.find((item:any) => +item.VALUE === parseInt(UNDER15_AMOUNT));
            }
          }
        }
      } else {
        insuredAmt = insuredAmtOptRes?.OPTIONS.LIFE.find((item:any) => +item.VALUE === parseInt(this.props.tempCalcFormVal.OVER15_AMOUNT));
      }
      // 用身故失能保額去計算並更新醫療保額
      const medical = insuredAmt ? this.handleGetMedical(insuredAmtOptRes, `${insuredAmt.VALUE}`) : null;
      medicalAmtText = medical ? commonService.handleConvertAmount(medical.VALUE) : '';
      medicalAmtVal = medical ? medical.VALUE : '';
      const memberId = memberInfo.MEMBER_ID || memberInfo.INSURED_ID;
      let fee = 0;
      if (insuredAmtOptRes) {
        // 取得保費試算結果，更新投保金額
        if (medical && insuredAmt) {
          const res: any = await this.handleFetchReCalcRes(memberId, birthday, `${insuredAmt.VALUE}`, planData, medical);
          if (res && typeof res !== 'string') {
            fee = res.DATA[0].FEE;
          }
        }
      }

      saveArray.push({
        INSURED_RELATION: memberInfo.INSURED_RELATION || InsuredRelation.Self,
        INSURED_RELATION_NAME: memberInfo.INSURED_RELATION_NAME || this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Self),
        INSURED_NAME: memberInfo.NAME || memberInfo.INSURED_NAME,
        INSURED_ID: memberInfo.MEMBER_ID || memberInfo.INSURED_ID,
        INSURED_ID_VALID: true,
        INSURED_BIRTHDAY: birthdayVal,
        INSURED_ID_ERROR: memberInfo.INSURED_ID_ERROR || false,
        INSURED_BIRTHDAY_ERROR: memberInfo.INSURED_BIRTHDAY_ERROR || false,
        INSURED_CONTRACT_AGE: insuredAge,
        INSURED_IS_UNDER15: insuredAge < 15,
        INSURED_MOBILE: memberInfo.MOBILE || memberInfo.INSURED_MOBILE,
        INSURED_EMAIL_ADDR: memberInfo.EMAIL_ADDR || memberInfo.INSURED_EMAIL_ADDR,
        INSURED_AGE_LIMIT_AMT: this.handleAgeLimitAmt(insuredAge),
        INSURED_AMT_OPTS: (fee && insuredAmtOptRes) || (!fee && birthday) ? { ...insuredAmtOptRes } : null,
        INSURED_AMT: fee && insuredAmt ? `${insuredAmt.VALUE}` : insuredAmtOptRes?.OPTIONS.LIFE.filter((item:any) => +item.VALUE === +this.props.tempCalcFormVal.OVER15_AMOUNT).length ?? 0 > 0
          ? '' : '',
        INSURED_AMT_NAME: fee && insuredAmt ? `${+insuredAmt.VALUE / 10000}萬` : '',
        INSURED_MFUNERAL: this.props.tempFill2nd.tempFill2ndFormVal?.INSUREDS[index].INSURED_MFUNERAL ? (this.props.tempFill2nd.tempFill2ndFormVal?.INSUREDS[index].INSURED_MFUNERAL !== 0 ? this.props.tempFill2nd.tempFill2ndFormVal?.INSUREDS[index].INSURED_MFUNERAL : 0) : 0,
        // INSURED_MFUNERAL: fee ? medicalAmtText : '',
        INSURED_MEDICAL: fee ? medicalAmtText : '',
        INSURED_MEDICAL_VALUE: fee ? medicalAmtVal : '',
        INSURED_MEDICAL_NAME: fee ? medicalAmtText : '',
        INSURED_CALC: fee ? `${fee}` : ''
      });
      planData = this.handleUpdatePlandata(saveArray, planData);
      return planData;
    }

    /**
     * @description 取得被保險人物件流水號、被保險人 ID 、 生日 、 失能保額等欄位值進行保費計算
     */
    handleFetchReCalcRes = async (
      insuredId: string, birthdayVal: string, insuredAmt: string,
      oldPlanData: EvalExpans, medical?: MedicalContent | null) => {
      if (!insuredId || !birthdayVal || !insuredAmt || !medical) return;
      const dataReqContent: DATAReqContent = {
        ID: insuredId,
        BIRTHDAY: birthdayVal,
        LIFE: +insuredAmt,
        MEDICAL: +medical.VALUE,
        MFUNERAL: 0
      };

      const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue;

      // 建立保費計算用 Request Model
      const policyReq: PolicyFeeReq = {
        INS_TYPE_ID: oldPlanData.INS_TYPE_ID,
        PROD_ID: oldPlanData.PROD_ID,
        PLAN_ID: oldPlanData.HEADER.PLAN_ID,
        CLASS: '1',
        START_DATE: moment(calcFormVal.START_DATE).format('YYYYMMDD'),
        END_DATE: moment(calcFormVal.END_DATE).format('YYYYMMDD'),
        DATA: [{ ...dataReqContent }]
      };
      return await service.fetchPolocyFee(policyReq);
    }

    /**
     * @description 取得系統參數值
     */
    handleFetchSysOpts = async () => {
      const sysOptionReq: SysOptionReq = {
        PCLASS: [SysOptType.RELATIONT, SysOptType.NATIONALITY]
      };

      const res = await apiCommonService.fetchSysOpts(sysOptionReq);
      if (res) {
        const policyDeliverySysOpts = await apiCommonService.getDeliveryMethods(InsType.Travel);
        this.setState({
          policyDeliverySysOpts: policyDeliverySysOpts ?? [],
          relationSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.RELATIONT])),
          nationalitySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.NATIONALITY]))
        });
        // init formik form values
        if (policyDeliverySysOpts && policyDeliverySysOpts.length > 0) {
          initialValues = {
            ...initialValues,
            DELIVERY: policyDeliverySysOpts[0].PARAM_VALUE
          };
        }
      }
    }

    /**
     * @description 取得要保人聲明事項初始值
    */
    handleGetKycInfos = (kycCondition: KYC_INIT_CONDITION = defaultKycCond) => {
      // 推論 KYC 第一題預設答案 (限定第一次進此頁會執行)
      const kyc01Answer = (condition: KYC_INIT_CONDITION) => {
        const { INS_COUNT, INSURED_SUBJECT, OVER15_COUNT, UNDER15_COUNT } = condition;
        // 一人投保答案推論
        if (INS_COUNT === InsCount.One) {
          if (+INSURED_SUBJECT === +InsureSubject.Self && +OVER15_COUNT === 1) return '1';
          if (+UNDER15_COUNT === 1) return '3';
          if (+INSURED_SUBJECT === 2 && +OVER15_COUNT === 1) return '2';
        }
        // 多人投保答案推論
        if (INS_COUNT === InsCount.MORE) {
          if (+OVER15_COUNT === 1 || +INSURED_SUBJECT === +InsureSubject.All) return '1';
          if (+OVER15_COUNT === 0) return '3';
          if (+OVER15_COUNT > 0 && +INSURED_SUBJECT === +InsureSubject.Self && +UNDER15_COUNT > 0) return '1';
        }
        return '';
      };
      const tempKycInfos = this.props.tempFill2nd.tempFill2ndFormVal?.KYCINFOS;
      const res = new Array(0);
      if (this.props.kycClaims && this.props.kycClaims.length > 0) {
        _.forEach(this.props.kycClaims, (this.props.kycClaims, (kycClaim: KycClaim) => {
          let ansKey = '';
          let ansText = '';
          let other = '';
          const tempKycVal: KycInfo | undefined = tempKycInfos?.find(it => it.KYC_ID === kycClaim.KYC_ID);
          // KYC 第一題單獨處理
          if (kycClaim.KYC_ID === 'KYC01') {
            if (tempKycVal) {
              // 已有緩存，則帶入緩存資料
              ansKey = tempKycVal.KYC_ANSWER;
              ansText = tempKycVal.KYC_ANSWER_TEXT;
              other = tempKycVal.KYC_OTHER ?? '';
            } else {
              // 無緩存，則根據傳入條件推論預設答案
              ansKey = kyc01Answer(kycCondition);
              const option = kycClaim.KYC_OPTIONS.find(it => it.KEY === ansKey);
              ansText = option?.VAL ?? '';
            }
          } else {
            if (tempKycVal) {
              ansKey = tempKycVal.KYC_ANSWER;
              ansText = tempKycVal.KYC_ANSWER_TEXT;
              other = tempKycVal.KYC_OTHER ?? '';
            }
          }
          res.push({
            KYC_ID: kycClaim.KYC_ID,
            KYC_SUBJECT: kycClaim.KYC_SUBJECT,
            KYC_ANSWER: ansKey,
            KYC_ANSWER_TEXT: ansText,
            KYC_OTHER: other
          });
        }));
      }
      return res;
    }

    /**
     * @description 判斷是否大於 80 歲且需同步第一被保人
     * @param birthday 生日日期
     * @param insureSubject 投保對象資料
     */
    handleIsAgeLimit = async (birthday: any, insureSubject: any) => {
      if (!birthday) return false;

      let res = false;
      const insuredAge = await this.handleGetInsuredAge(birthday);
      const actualAge = await this.handleGetActualAge(birthday);

      if (!this.hasAgeLimitAmt(insuredAge) && insureSubject?.PARAM_VALUE !== InsureSubject.Relatives) {
        this.handleShowErrorMsg(CodeId.W006);
        res = true;
      }

      // if (!res && age < 7) {
      //   this.handleShowErrorMsg(CodeId.W003);
      //   res = true;
      // }

      const policeAgeLimit = this.getPolicyAgeLimit(this.props.tempCalcFormVal.PROD_ID);

      if (!policeAgeLimit) throw new Error('無法取得要保人年齡限制');

      if (!res && actualAge < +policeAgeLimit) {
        this.handleShowErrorMsg(CodeId.W088);
        res = true;
      }

      return res;
    }

    getPolicyAgeLimit = (prodId: string) => {
      switch (prodId) {
        case TravelPlanType.Abroad:
          return this.props.tempCalc.policyAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.Abroad)[0].PARAM_VALUE;
        case TravelPlanType.Domestic:
          return this.props.tempCalc.policyAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.Domestic)[0].PARAM_VALUE;
        case TravelPlanType.NTAG:
          return this.props.tempCalc.policyAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.NTAG)[0].PARAM_VALUE;
      }
    }

    /**
     * @description 設定登入者的職業選項，並帶入登入者資訊
     */
    handleSetOccupationAndMemberInfo = (memberInfo: any) => {
      let occupationId = '';
      // 取得職業類別中文名稱
      let occupationIdName = '';
      let occupationDescName = '';
      if (this.props.occupations && memberInfo.OCCUPATION_DOMAIN_ID) {
        occupationId = memberInfo.OCCUPATION_DOMAIN_ID;
        const occupationInfo = _.find(this.props.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === memberInfo.OCCUPATION_DOMAIN_ID);
        if (occupationInfo) {
          occupationIdName = occupationInfo.OCCUPATION_NAME;

          const occupationContentInfo = _.find(occupationInfo.OCCUPATION, (content: OccupationContent) => content.OCCUPATION_ID === memberInfo.OCCUPATION_ID);

          if (occupationContentInfo) {
            occupationDescName = occupationContentInfo.OCCUPATION_NAME;
          }
        }
      }

      initialValues = {
        ...initialValues,
        ...memberInfo,
        OCCUPATION_DOMAIN_ID_NAME: occupationIdName,
        OCCUPATION_ID_NAME: occupationDescName
      };

      this.setState({ hidePolicyID: true });

      return occupationId;
    }

    // #endregion

    // #region 視窗相關事件

    // 新增 window scroll 事件監聽
    addWindowScrollEvent = () => {
      window.addEventListener('scroll', this.toggleProgramSummaryVisible, false);
    }

    // 移除 window scroll 事件監聽
    removeWindowScrollEvent = () => {
      window.removeEventListener('scroll', this.toggleProgramSummaryVisible, false);
    }

    // 開啟/關閉 方案詳細資訊
    handleProgramDetailsToggle = () => {
      this.setState(state => ({ ...state, programDetailsOpen: !this.state.programDetailsOpen }));
    }

    // 開啟/關閉 方案詳細資訊 (方案摘要區塊)
    handleProgramSummaryDetailsToggle = () => {
      this.setState(state => ({ ...state, programSummaryDetailsOpen: !this.state.programSummaryDetailsOpen }));
    }

    // 視窗滾動至「要保人資料」區塊時，顯示「旅遊資訊」方案摘要區塊 (Fixed 在 Header 下方)
    toggleProgramSummaryVisible = () => {
      const headerHeight = 72;
      const policyholderInfoOffsetTop = (window.pageYOffset + this.policyholderInfoRef.current!.getBoundingClientRect().top) - headerHeight;
      const scrollTopPosition = window.pageYOffset;

      this.setState(state => ({
        ...state,
        programSummaryVisible: (scrollTopPosition > policyholderInfoOffsetTop)
      }));
    };

    // #endregion

    // #region 表單上下一步相關事件

    /**
     * @description 表單 Submit 事件
    */
    handleOnSubmit = async (values: IFill2ndFormValue, actions: FormikHelpers<IFill2ndFormValue>) => {
      this.handleCheckAllInsuredBirthdayThroughInsuredRelation(values);
      // this.handleCheckPlanAllInsuredsBirthday();
      /** 方案的人數 */
      const planSubOver15 = +this.props.tempCalcFormVal.OVER15_COUNT;
      const planSubUnder15 = +this.props.tempCalcFormVal.UNDER15_COUNT;
      /** 被保險的人數 */
      const currentSubOver15 = values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === false).length;
      const currentSubUnder15 = values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === true).length;
      /** 被保險人數與方案人數相符合，則跳出提醒給予使用者 */
      if (planSubOver15 !== currentSubOver15 || planSubUnder15 !== currentSubUnder15) {
        const result = await sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${commonService.getCodeMsg(this.props.UICode, CodeId.W077)}`,
          showConfirmButton: true,
          showCancelButton: true
        });
        if (result.dismiss) return;
      }

      // 取得網要網投判斷結果
      const applyType = await this.handleGetApplyType(values);
      if (!applyType) return;

      const serialType = ApplyNoType.WebRequire;

      const serialNo = await service.fetchPolicyNo(this.state.prodId, serialType, applyType);
      if (!serialNo) return;

      // 手機與電子郵件檢核 (2024/04/02)
      const verifyRes = await this.verifyMailAndMobile(values);
      if (!verifyRes) return;

      // 進行API檢核
      const validRes = await this.handleRuleValid(values, applyType, serialNo);
      if (!validRes) return;

      if (validRes && validRes.ERROR_MSG.length > 0) {
        this.props.setRuleValidErrorModalVisible(true, validRes.ERROR_MSG);
        return;
      }

      const tempFill2ndState = {
        ...this.state,
        applyType: applyType,
        serialNo: serialNo
      };

      this.setState({ ...tempFill2ndState });

      this.props.onSubmit(values, tempFill2ndState);
    }

    /**
     * @description 處理 Submit 按鈕 onClick 執行的事件
     */
    // handleSubmitButtonOnClick = () => {
    //   this.handleCheckAllInsuredBirthdayThroughInsuredRelation();
    // };

    /**
     * @description 取得網要/網投
    */
    handleGetApplyType = async (values: IFill2ndFormValue) => {
      const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue; // { ...this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal };

      // 外國人 特定活動 登山 可以保外國人 但只限 "網要"
      if (
        (calcFormVal.PROD_ID === TravelPlanType.MPA || calcFormVal.PROD_ID === TravelPlanType.SPI) &&
            values.NATIONALITY_TYPE === NationalType.Foreigner
      ) return ApplyType.WebRequire;

      // 判斷網要、網投
      const checkApplyTypeReq: CheckApplyTypeReq = {
        ONEORMORE: this.state.insCount,
        INSUREDSUBJECT: this.state.insureSubject?.PARAM_VALUE as string,
        CONTRACT_DATE: moment(calcFormVal.START_DATE).format('YYYYMMDD'),
        APPLICANT_ID: values.MEMBER_ID,
        APPLICANT_BIRTHDAY: moment(values.BIRTHDAY).format('YYYYMMDD'),
        APPLICANT_NAME: values.NAME,
        INSURED_DATA: _.map(values.INSUREDS, (insured: InsuredState) => {
          const insuredData: InsuredDataContent = {
            ID: insured.INSURED_ID,
            BIRTHDAY: moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD'),
            NAME: insured.INSURED_NAME,
            RELATION: insured.INSURED_RELATION
          };
          return insuredData;
        })
      };

      // 取得網要網投判斷結果
      let applyType = await service.validApplyType(checkApplyTypeReq, this.state.planData?.INS_TYPE_ID as string);
      if (!applyType) return;

      // 若為網投，判斷是否登入，已登入將狀態改為網投，未登入且不進行登入，狀態維持網要
      if (applyType === ApplyType.WebInsured) {
        const loginInfo = storageService.getItem(storageKeys.LoginInfo);
        if (!loginInfo) {
          return sweetAlertService.modal({
            html: commonService.getCodeMsg(this.props.UICode, CodeId.W008),
            showCancelButton: true,
            showCloseButton: true
          }).then(res => {
            if (res.value) {
              this.props.onTempData();
              const path = {
                pathname: RouterSettings.Login,
                state: { originUrl: RouterSettings.InsureProcess.Travel }
              };

              this.props.history.push(path);
              return;
            }

            if (res.dismiss) {
              applyType = ApplyType.WebRequire;
              return applyType;
            }
          });
        }
      }

      return applyType;
    }

    /**
     * @description 手機與電子郵件檢核
     * @param values 表單值
     */
    verifyMailAndMobile = async (values: IFill2ndFormValue) => {
      // 15 歲以下子女免送檢核
      const args: InfoCheckmailandmobileReq = {
        CHECKMAILANDMOBILE: [
          // 要保人
          {
            SEQ: '01',
            NAME: values.NAME,
            MOBILE: values.MOBILE,
            MAIL: values.EMAIL_ADDR
          },
          // 被保人
          ...values.INSUREDS.filter(it => !it.INSURED_IS_UNDER15).map((it, index) => ({
            SEQ: String(index + 2).padStart(2, '0'),
            NAME: it.INSURED_NAME,
            MOBILE: it.INSURED_MOBILE,
            MAIL: it.INSURED_EMAIL_ADDR
          }))
        ]
      };
      const response = await apiCommonService.validMailAndMobile(args);
      if (!response) return false;
      if (response && response.CHECKMAILANDMOBILE) {
        if (response.CHECKMAILANDMOBILE.some(it => it.ISSUCCESS !== 'Y')) {
          const errorMsg: string[] = response.CHECKMAILANDMOBILE.filter(it => it.ISSUCCESS !== 'Y').map(it => it.MESSAGE);
          // 呈現多則檢核失敗
          this.props.setRuleValidErrorModalVisible(true, errorMsg);
          return false;
        }
      }
      // 檢核成功
      return true;
    }

    /**
     * @description 保單規則檢核
    */
    handleRuleValid = async (values: IFill2ndFormValue, applyType: string, serialNo: string) => {
      const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue; // { ...this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal };
      const spiAttached = this.props.tempCalc.evalReq?.SPI_ATTACHED;
      const tempTravels = [...this.props.tempFill1st.tempFill1stState?.tempTravels as TravelWarningExpandData[]];
      const insureds = [...values.INSUREDS];

      const insuredDatas = _.map(insureds, (insured: InsuredState) => {
        let ocpType = OccupationIdType.RuleCheckNormal;
        if (insured.INSURED_RELATION === InsuredRelation.Self) {
          switch (values.OCCUPATION_DOMAIN_ID) {
            case OccupationIdType.Normal:
              ocpType = OccupationIdType.RuleCheckNormal;
              break;
            case OccupationIdType.Special:
              ocpType = OccupationIdType.RuleCheckSpecial;
              break;
          }
        }

        let nativeId = GeoAreaId.Domestic;
        if (insured.INSURED_ID[1] !== IdInfoType.NationalMale && insured.INSURED_ID[1] !== IdInfoType.NationalFemale) {
          nativeId = GeoAreaId.Other;
        }

        const insuredCheckData: InsuredRuleCheckContent = {
          ROLE_TYPE: RuleCheckInsuredType.Insured,
          ID: insured.INSURED_ID,
          NAME: insured.INSURED_NAME,
          BIRTHDAY: moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD'),
          LIFE: insured.INSURED_AMT,
          MEDICAL: insured.INSURED_MEDICAL,
          MFUNERAL: String(insured.INSURED_MFUNERAL),
          NATIVE_ID: nativeId,
          OCP_TYPE: ocpType,
          FEE: +insured.INSURED_CALC
        };
        return insuredCheckData;
      });

      const totalAmt = _.reduce(_.map(insureds, (insured: InsuredState) => +insured.INSURED_CALC), (sum: any, n: any) => {
        return sum + n;
      }, 0);

      const policyholders = {
        ROLE_TYPE: RuleCheckInsuredType.Applicant,
        ID: values.MEMBER_ID,
        NAME: values.NAME,
        BIRTHDAY: moment(values.BIRTHDAY).format('YYYYMMDD'),
        LIFE: '0',
        MEDICAL: '0',
        MFUNERAL: '0',
        NATIVE_ID: values.NATIONALITY_TYPE === NationalType.National
          ? GeoAreaId.Domestic
          : GeoAreaId.Other,
        OCP_TYPE: values.OCCUPATION_DOMAIN_ID === OccupationIdType.Normal
          ? OccupationIdType.RuleCheckNormal
          : OccupationIdType.RuleCheckSpecial,
        FEE: totalAmt
      };
      insuredDatas.unshift(policyholders);

      // 建立檢核用 Request Model
      const ruleCheckReqContent: RuleCheckReqContent = {
        INS_TYPE_ID: this.state.planData?.INS_TYPE_ID as string,
        PROD_ID: this.state.planData?.PROD_ID as string,
        PLAN_ID: this.state.planData?.HEADER.PLAN_ID as string,
        SPI_ATTACH: spiAttached || '',
        BC_TYPE: applyType,
        APPLY_NO: serialNo,
        START_DATE: moment(calcFormVal.START_DATE).format('YYYYMMDD'),
        END_DATE: moment(calcFormVal.END_DATE).format('YYYYMMDD'),
        DESTINATION_ID: _.map(tempTravels, (travel: TravelWarningExpandData) => {
          return travel.COUNTRY_ID as string;
        }),
        INSURED_DATA: insuredDatas,
        START_HOUR: this.props.tempCalc.evalReq?.START_HOUR as string
      };

      const ruleValidReq: RuleValidReq = {
        RULECHECK: { ...ruleCheckReqContent }
      };

      return await service.policyRuleCheck(ruleValidReq);
    }

    /**
     * @description 點選回上一頁事件
    */
    handleGoBack = () => {
      this.props.onGoBack(this.formikRef.current.values, this.state);
    }

    // #endregion

    // #region OK 欄位相關事件

    /**
     * @description 職業類別的 Change 事件
     */
    handleOccupationIdChange = (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
      commonService.setSelectOptName(setFieldValue, 'OCCUPATION_DOMAIN_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);

      this.setState({ occupationId: e.currentTarget.value });

      if (!e.target.value || e.currentTarget.value === OccupationIdType.Special) {
        setFieldValue('OCCUPATION_ID', '');
        setFieldValue('OCCUPATION_ID_NAME', '');
      }

      if (e.target.value === OccupationIdType.Normal) {
        const occupation =
                _.find(this.props.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === e.target.value);

        if (!occupation) return;

        setFieldValue('OCCUPATION_ID', occupation.OCCUPATION[0].OCCUPATION_ID);
        setFieldValue('OCCUPATION_ID_NAME', '');
      }
    };

    /** 取得電子信箱常用 Domain Name */
    handleGetDomainSource = (val: string) => {
      const emailDNs: any = new Array(0);
      // 有輸入值，且尚未輸入 @ 呈現常用 Domain Name 選單
      if (val && val.indexOf('@') === -1) {
        _.map(this.props.emailDomains, (emailDomain: EmailDomain) => {
          emailDNs.push({ value: `${val}@${emailDomain.EMAIL_DOMAIN_NAME}` });
        });
      }
      return emailDNs;
    }

    /**
     * @description 檢核帳號是否已存在格式是否正確
     */
    onValidID = _.debounce(async (val: any, nationalityType: string) => {
      if (this.state.hasMemberId || !this.formikRef || !this.formikRef.current) return;
      if (val && val.length === 10) {
        const errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
        this.formikRef.current.setFieldError('MEMBER_ID', errorVal);
        this.setState({ memberIdErrMsg: errorVal });
      }
    }, 500);

    /**
     * @description 檢核全部「被保險人資料」，依據當前的「要保人關係」檢核生日
     */
    handleCheckAllInsuredBirthdayThroughInsuredRelation = (values: IFill2ndFormValue) => {
      values.INSUREDS.forEach((item: InsuredState, index: number) => {
        this.handleCheckInsuredBirthdayThroughInsuredRelation(moment(item.INSURED_BIRTHDAY), index);
      });
    };

    /**
     * @description 依據當前的「要保人關係」檢核生日
     * @param date 日期
     * @param index 資料索引值
     */
    handleCheckInsuredBirthdayThroughInsuredRelation = async (date: Moment, index: number) => {
      // const age = moment().diff(date, 'years');
      if (date === null || date.format('YYYYMMDD') === 'Invalid date') return;
      const age = await this.handleGetInsuredAge(date.format('YYYYMMDD'));
      if (
        (this.state.insCount === InsCount.One || this.state.insCount === InsCount.MORE) &&
        this.state.insureSubject?.PARAM_VALUE === InsureSubject.Self &&
        this.state.prodId !== TravelPlanType.NTAG
      ) {
        if (this.formikRef.current.values.INSUREDS[index].INSURED_RELATION === InsuredRelation.Child) {
          const insuredAgeLimit = this.getInsuredAgeLimit(this.props.tempCalcFormVal.PROD_ID);
          if (!insuredAgeLimit) throw new Error('無法取得被保人年齡限制');
          const isUnder7Age = age < +insuredAgeLimit;
          this.setState({ insuredsBirthdayErrMsg: !isUnder7Age ? '年齡需未滿 7 歲' : '' });
          this.formikRef.current.setFieldError(`INSUREDS[${index}].INSURED_BIRTHDAY`, !isUnder7Age ? '年齡需未滿 7 歲' : '');
          this.formikRef.current.setFieldTouched(`INSUREDS[${index}].INSURED_BIRTHDAY`, true);
          this.formikRef.current.setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, !isUnder7Age);
          return;
        }
      }
      if (
        this.state.insCount === InsCount.One &&
        this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives &&
        this.state.prodId !== TravelPlanType.NTAG
      ) {
        if (this.formikRef.current.values.INSUREDS[index].INSURED_RELATION) {
          const insuredAgeLimit = this.getInsuredAgeLimit(this.props.tempCalcFormVal.PROD_ID);
          if (!insuredAgeLimit) throw new Error('無法取得被保人年齡限制');
          const isOver7Age = age >= +insuredAgeLimit;
          this.setState({ insuredsBirthdayErrMsg: !isOver7Age ? '年齡需滿 7 歲以上' : '' });
          this.formikRef.current.setFieldError(`INSUREDS[${index}].INSURED_BIRTHDAY`, !isOver7Age ? '年齡需滿 7 歲以上' : '');
          this.formikRef.current.setFieldTouched(`INSUREDS[${index}].INSURED_BIRTHDAY`, true);
          this.formikRef.current.setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, !isOver7Age);
          return;
        }
      }
      if (this.state.prodId === TravelPlanType.NTAG) {
        if (this.formikRef.current.values.INSUREDS[index].INSURED_RELATION) {
          const insuredAgeLimit = this.getInsuredAgeLimit(this.props.tempCalcFormVal.PROD_ID);
          if (!insuredAgeLimit) throw new Error('無法取得被保人年齡限制');
          const isOver15Age = age >= +insuredAgeLimit;
          this.setState({ insuredsBirthdayErrMsg: !isOver15Age ? '年齡需滿 15 歲以上' : '' });
          this.formikRef.current.setFieldError(`INSUREDS[${index}].INSURED_BIRTHDAY`, !isOver15Age ? '年齡需滿 15 歲以上' : '');
          this.formikRef.current.setFieldTouched(`INSUREDS[${index}].INSURED_BIRTHDAY`, true);
          this.formikRef.current.setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, !isOver15Age);
          return;
        }
      }
      this.setState({ insuredsBirthdayErrMsg: '' });
      this.formikRef.current.setFieldError(`INSUREDS[${index}].INSURED_BIRTHDAY`, '');
      this.formikRef.current.setFieldTouched(`INSUREDS[${index}].INSURED_BIRTHDAY`, true);
      this.formikRef.current.setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, false);
    };

    getInsuredAgeLimit = (prodId: string) => {
      switch (prodId) {
        case TravelPlanType.Abroad:
          return this.props.tempCalc.insuredAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.Abroad)[0].PARAM_VALUE;
        case TravelPlanType.Domestic:
          return this.props.tempCalc.insuredAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.Domestic)[0].PARAM_VALUE;
        case TravelPlanType.NTAG:
          return this.props.tempCalc.insuredAgeLimitOpts?.filter(opt => opt.PARAM_ID === TravelPlanType.NTAG)[0].PARAM_VALUE;
      }
    }

    /**
     * @description submit 後，檢核被保險人與方案是否匹配
     */
    handleCheckPlanAllInsuredsBirthday = () => {
      /** 方案的人數 */
      const planSubOver15 = +this.props.tempCalcFormVal.OVER15_COUNT;
      const planSubUnder15 = +this.props.tempCalcFormVal.UNDER15_COUNT;
      /** 被保險的人數 */
      const currentSubOver15 = this.formikRef.current.values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === false).length;
      const currentSubUnder15 = this.formikRef.current.values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === true).length;

      /** 若與方案人數不符合 */
      if (planSubUnder15 !== currentSubUnder15 && planSubOver15 !== currentSubOver15) {
        /** 若與方案人數不相符合 */
        this.setState({ insuredsBirthdayErrMsg: '被保險人的年齡與您所選的方案人數、年齡不相符' });
        /** 判斷是否含有本人 */
        let isIncludeSelf = false;
        /** 被保人的生日 */
        this.formikRef.current.values.INSUREDS.forEach((item: any, index: number) => {
          this.formikRef.current.setFieldError(`INSUREDS[${index}].INSURED_BIRTHDAY`, '被保險人的年齡與您所選的方案人數、年齡不相符');
          this.formikRef.current.setFieldTouched(`INSUREDS[${index}].INSURED_BIRTHDAY`, true);
          if (item.INSURED_RELATION === '1') isIncludeSelf = true;
        });
        /** 要保人的生日 */
        if (isIncludeSelf) {
          this.setState({ birthdayErrMsg: '被保險人的年齡與您所選的方案人數、年齡不相符' });
          this.formikRef.current.setFieldError('BIRTHDAY', '被保險人的年齡與您所選的方案人數、年齡不相符');
          this.formikRef.current.setFieldTouched('BIRTHDAY', true);
        }
      }
    }

    /**
     * @description 選擇被保險人生日時，檢核被保險人與方案是否匹配
     */
    handleCheckPlanSingleInsuredBirthday = (val: any, index: number) => {
      const targetIsUnder15 = this.formikRef.current.values.INSUREDS[index].INSURED_IS_UNDER15;
      const isUnder15 = moment().diff(val, 'days') < 365 * 15;
      /** 方案的人數 */
      const planSubOver15 = +this.props.tempCalcFormVal.OVER15_COUNT;
      const planSubUnder15 = +this.props.tempCalcFormVal.UNDER15_COUNT;
      /** 被保險的人數 */
      let currentSubOver15 = this.formikRef.current.values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === false).length;
      let currentSubUnder15 = this.formikRef.current.values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === true).length;

      /** 若是修改被保險人情況 */
      if (val && val._i) {
        /** 原先未滿 15 調整滿 15 */
        if (targetIsUnder15 && !isUnder15) {
          currentSubUnder15--;
          currentSubOver15++;
        }
        /** 原先滿 15 調整未滿 15 */
        if (!targetIsUnder15 && isUnder15) {
          currentSubUnder15++;
          currentSubOver15--;
        }
      }

      /** 若與方案人數相符合 */
      if (planSubUnder15 === currentSubUnder15 && planSubOver15 === currentSubOver15) {
        this.setState({ birthdayErrMsg: '' });
        this.setState({ insuredsBirthdayErrMsg: '' });
      } else {
        let isIncludeSelf = false;
        /** 被保人的生日 */
        this.formikRef.current.values.INSUREDS.forEach((item: any, index: number) => {
          if (item.INSURED_RELATION === '1') isIncludeSelf = true;
        });
        /** 要保人的生日 */
        if (!isIncludeSelf) {
          this.setState({ birthdayErrMsg: '' });
          this.formikRef.current.setFieldError('BIRTHDAY', '');
        }
      }
    }

    /**
     * @description 檢核外國人，選取的商品種類是否可以投保
    */
    handleCheckProdId = (nationalityType: string) => {
      const { tempCalcFormVal } = this.props.tempCalc;
      if (!tempCalcFormVal || !nationalityType || nationalityType !== NationalType.Foreigner) return false;

      const prodId = tempCalcFormVal.PROD_ID;

      if (prodId === TravelPlanType.Domestic || prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG || prodId === TravelPlanType.TBP) {
        // this.props.setInfoModalVisible(true, '', '此商品尚未提供非本國人投保，請確認');

        this.props.setInfoModalVisible(true, '', `${commonService.getCodeMsg(this.props.UICode, CodeId.W073)}`);
        return true;
      }

      return false;
    }

    /**
     * @description 取得實際年齡
     * @param birthday 投保人生日日期
    */
    handleGetActualAge = async (birthday: any) => {
      const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
      const formatedBirthday = typeof birthday === 'string' ? moment(birthday).format('YYYYMMDD') : birthday.format('YYYYMMDD');
      const ageData: ActualAgeData = {
        EXAM_DATE: moment.unix(sysTime).format('YYYYMMDD'),
        BIRTHDAY: formatedBirthday
      };

      const res = await service.fetchActualAge([ageData]);
      if (!res) return 0;

      return res[0].ACTUAL_AGE as number;
    }

    // #endregion

    // #region 被保險人區塊相關方法

    /**
     * @description 取得投保年齡
     * @param birthday 投保人生日日期
    */
    handleGetInsuredAge = async (birthday: any) => {
      const startDate = this.props.tempCalc.tempCalcFormVal?.START_DATE; // this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal.INSURED_RANGE;
      const formatedBirthday = typeof birthday === 'string' ? moment(birthday).format('YYYYMMDD') : birthday.format('YYYYMMDD');
      const ageData: AgeData = {
        CONTRACT_DATE: moment(startDate).format('YYYYMMDD'),
        BIRTHDAY: formatedBirthday
      };

      const res = await memberProfileService.validContractAge([ageData]);
      if (!res) return 0;

      return res[0].CONTRACT_AGE as number;
    }

    /**
     * @description 新增被保險人區塊
    */
    handleAddInsured = async (values: IFill2ndFormValue, pushAction: any) => {
      // 判斷是否超過可投保數
      if (values.INSUREDS.length + 1 > InsuredPersonMatch[this.state.insCount as InsCount]) return '';

      /** 方案的人數 */
      // const planSubOver15 = +this.props.tempCalcFormVal.OVER15_COUNT;
      // const planSubUnder15 = +this.props.tempCalcFormVal.UNDER15_COUNT;
      /** 被保險的人數 */
      // const currentSubOver15 = values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === false).length;
      // const currentSubUnder15 = values.INSUREDS.filter((item: any) => item.INSURED_IS_UNDER15 === true).length;
      /** 被保險人數與方案人數相符合，則跳出提醒給予使用者 */
      // 取消人數須與保費試算人數相同之檢核
      // if (planSubOver15 === currentSubOver15 && planSubUnder15 === currentSubUnder15) {
      //   sweetAlertService.modal({
      //     icon: SweetAlertIcon.Info,
      //     html: '被保險人數已達上限。若您要新增更多被保險人，請調整投保人數'
      //   });
      //   return;
      // }
      // if (planSubOver15 + planSubUnder15 <= currentSubUnder15 + currentSubOver15) {
      //   sweetAlertService.modal({
      //     icon: SweetAlertIcon.Info,
      //     html: '被保險人數已達上限。若您要新增更多被保險人，請調整投保人數'
      //   });
      //   return;
      // }

      setTimeout(() => {
        if (this.lastInsuredRef && this.lastInsuredRef.current) {
          this.lastInsuredRef.current.scrollIntoView();
          // 視窗滾動高度需減去 Header 高度
          const scrolledY = window.scrollY;
          const headerHeight = 140;
          window.scroll(0, scrolledY - headerHeight);
        }
      });

      pushAction({ ...initInsured });
    }

    /**
     * @description 移除被保險人區塊
    */
    handleDeleteInsured = (index: number, values: IFill2ndFormValue, removeAction: any) => {
      let planData: any = { ...this.state.planData };
      const insureds = [...values.INSUREDS];
      const targetInsured = insureds.splice(index, 1)[0];
      if (targetInsured.INSURED_CALC) {
        targetInsured.INSURED_CALC = '';
        insureds.splice(index, 0, targetInsured);
        planData = this.handleUpdatePlandata(insureds);
      }

      removeAction(index);

      insureds.splice(index, 1);

      this.setState({ planData: planData });
    }

    /**
     * @description 取得與被保險人關係下拉選單值
    */
    handleGetRelationOpts = () => {
      if (this.state.relationSysOpts && this.state.relationSysOpts.length > 0) {
        return _.map(this.state.relationSysOpts, (sysOtps: SysOption, index: number) => {
          // 判斷條件:
          // 保險人數: 一人或多人投保、保險對象: 幫自己或未滿 7 歲子女投保、保險種類: 不為申根
          if (
            (this.state.insCount === InsCount.One || this.state.insCount === InsCount.MORE) &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Self &&
            this.state.prodId !== TravelPlanType.NTAG) {
            if (sysOtps.PARAM_VALUE !== InsuredRelation.Self && sysOtps.PARAM_VALUE !== InsuredRelation.Child) return;
          }
          // 判斷條件：
          // 保險人數：一人投保、保險對象：幫配偶或 7 歲以上親屬投保、保險種類: 不為申根
          if (
            this.state.insCount === InsCount.One &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives &&
            this.state.prodId !== TravelPlanType.NTAG) {
            // 不顯示「本人」、「其他」選項。
            if (sysOtps.PARAM_VALUE === InsuredRelation.Self || sysOtps.PARAM_VALUE === InsuredRelation.Other) return;
          }
          // 判斷條件:
          // 保險人數: 一人投保、保險對象: 幫自己投保、保險種類: 申根
          if (
            this.state.insCount === InsCount.One &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Self &&
            this.state.prodId === TravelPlanType.NTAG) {
            if (sysOtps.PARAM_VALUE !== InsuredRelation.Self) return;
          }
          // 判斷條件:
          // 保險人數: 一人投保、保險對象: 幫配偶或15歲以上親屬保、保險種類: 申根
          if (
            this.state.insCount === InsCount.One &&
            this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives &&
            this.state.prodId === TravelPlanType.NTAG) {
            if (sysOtps.PARAM_VALUE === InsuredRelation.Self) return;
          }
          return <option key={index} value={sysOtps.PARAM_VALUE}>{sysOtps.PARAM_TEXT}</option>;
        });
      }
    }

    /**
     * @description 顯示檢核錯誤訊息
    */
    handleShowErrorMsg = (codeId: string) => {
      // 顯示錯誤訊息
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICode, codeId)
      });
    }

    /**
     * @description 產生身故失能保額選項
    */
    handleCreateInsuredAmtOpt = (insuredAmtOpts: any) => {
      if (insuredAmtOpts && Object.keys(insuredAmtOpts).length > 0) {
        return _.map(insuredAmtOpts.OPTIONS.LIFE, (opt: LifeContent, index: number) => {
          return <option value={opt.VALUE} key={`${opt.VALUE}-${index}`}>{opt.TEXT}</option>;
        });
      }
    }

    /**
     * @description 產生喪葬費用選項
    */
    handleCreateInsuredFuneralOpt = (insuredAmtOpts: any) => {
      if (insuredAmtOpts && Object.keys(insuredAmtOpts).length > 0) {
        return _.map(insuredAmtOpts.OPTIONS.MFUNERAL, (opt: LifeContent, index: number) => {
          return <option value={opt.VALUE} key={`${opt.VALUE}-${index}`}>{opt.TEXT}</option>;
        });
      }
    }

    /**
     * @description 檢核判斷被保險人 身份證/居留證號 是否可繼續投保
    */
    handleValidInsuredId = (index: number, val: string, insureds: InsuredState[], setFieldValue: any) => {
      const insured = { ...insureds[index] };

      if (!val) {
        this.handleResetInsuredCalcInfo(index, insureds, setFieldValue, true, insured.INSURED_BIRTHDAY_ERROR);
        return;
      }

      // 輸入值長度大於 2
      const validCode = val.substr(1, 1);
      const prodId = this.state.prodId;

      // 判斷是否為外國人、且投保方案為 國內旅遊、國外旅遊、申根保險
      let isError = validCode !== IdInfoType.NationalMale && validCode !== IdInfoType.NationalFemale;
      isError = isError &&
            (prodId === TravelPlanType.Domestic || prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG);

      if (isError) {
        this.handleShowErrorMsg(CodeId.W005);
        setFieldValue(`INSUREDS[${index}].INSURED_ID`, '');
        this.handleResetInsuredCalcInfo(index, insureds, setFieldValue, true, insured.INSURED_BIRTHDAY_ERROR);
        return;
      }

      const targetInsured = insureds.splice(index, 1)[0];
      setFieldValue(`INSUREDS[${index}].INSURED_ID_ERROR`, false);
      targetInsured.INSURED_CALC = targetInsured.INSURED_CALC ? targetInsured.INSURED_CALC : '';
      targetInsured.INSURED_ID = val;
      targetInsured.INSURED_ID_ERROR = false;
      insureds.splice(index, 0, targetInsured);

      this.handleSetInsuredCalcByIdChange(index, insureds, setFieldValue);
    };

    /**
     * @description 被保人ID為本人，關係帶入本人
     */
    handleIsSelf = (setFieldValue: any, index: number, values: IFill2ndFormValue, insuredBirthday: Moment) => {
      setFieldValue(`INSUREDS[${index}].INSURED_RELATION`, InsuredRelation.Self);
      this.handleInsuredRelationChange(InsuredRelation.Self, index, values);
      this.handleCheckInsuredBirthdayThroughInsuredRelation(insuredBirthday, index);
    }

    /**
     * @description 取得保費計算結果，並更新資料，於被保險人區塊 身份證、身故失能保額欄位事件使用
    */
    handleSetInsuredCalcByIdChange = async (index: number, insureds: InsuredState[], setFieldValue: any) => {
      const tragetInsured = insureds.splice(index, 1)[0];
      const res: any = await this.handleFetchCalcRes(
        tragetInsured.INSURED_ID, tragetInsured.INSURED_BIRTHDAY,
        tragetInsured.INSURED_AMT, tragetInsured.INSURED_AMT_OPTS, String(tragetInsured.INSURED_MFUNERAL));

      if (res && typeof res !== 'string') {
        const insuredAge = await this.handleGetInsuredAge(tragetInsured.INSURED_BIRTHDAY);
        // 判斷是否小於 15 歲
        const isUnder15 = insuredAge < 15;
        if (!isUnder15 || this.formikRef.current.values.INSUREDS[index].INSURED_MFUNERAL !== 0) {
          setFieldValue(`INSUREDS[${index}].INSURED_CALC`, res.DATA[0].FEE);
        }
        setFieldValue(`INSUREDS[${index}].INSURED_CONTRACT_AGE`, insuredAge);
        setFieldValue(`INSUREDS[${index}].INSURED_IS_UNDER15`, isUnder15);
        tragetInsured.INSURED_CALC = res.DATA[0].FEE;
        tragetInsured.INSURED_CONTRACT_AGE = insuredAge;
        tragetInsured.INSURED_IS_UNDER15 = isUnder15;

        insureds.splice(index, 0, tragetInsured);

        const planData = this.handleUpdatePlandata(insureds);
        this.setState({ planData: planData });
      }
    }

    /**
     * @description 檢核被保險人生日 年齡是否大於 81、取得身故失能保額選項
    */
    handleInsuredBirthdayChange = async (index: number, birthdayVal: any, insureds: InsuredState[], setFieldValue: any) => {
      const insured = insureds[index];
      if (!birthdayVal) {
        this.handleResetInsuredCalcInfo(index, insureds, setFieldValue, insured.INSURED_ID_ERROR, true);
        return;
      }

      const insuredAge = await this.handleGetInsuredAge(birthdayVal);
      const tempNotices = [...this.state.notices];

      // 設定超過70歲提示訊息
      if (insuredAge > 70) {
        tempNotices[index] = ['國內旅遊或申根保險 : 限70歲以下投保;', '國外旅遊(非申根) : 70歲以上最高保額為 500 萬;', '多人投保時，15歲以上被保險人保額須相同，或請分開投保。'];
      } else {
        tempNotices[index] = [];
      };

      this.setState({ notices: [...tempNotices] });

      let planData = { ...this.state.planData } as EvalExpans;
      const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue; // { ...this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal };
      const birthday = moment(birthdayVal).format('YYYYMMDD');

      // 取得投保方案起始日
      const contractDate = moment(calcFormVal.START_DATE).format('YYYYMMDD');

      // 取得失能保額清單值
      const insuredAmtOptRes = await service.fetchInsuredAmtOpt(planData.INS_TYPE_ID, planData.PROD_ID, planData.HEADER.PLAN_ID, birthday, contractDate);

      // 清除失能保額、實支實付、投保金額等欄位值，更新失能保額清單值
      const insuredAmtOpts = insuredAmtOptRes ? _.cloneDeep(insuredAmtOptRes.OPTIONS.LIFE) : [];
      let insuredAmtVal: any = null;

      const isUnder15 = insuredAge < 15; // 判斷是否小於 15 歲
      const firstInsured = insureds.filter(item => item.INSURED_IS_UNDER15 === isUnder15)[0];
      const firstInsuredIndex = insureds.indexOf(firstInsured);
      const isFirstInsured = firstInsuredIndex === index;

      // 判斷是否為第一被保人
      if (isFirstInsured) {
        // 如果原本有值，嘗試帶入原本的值
        if (insured.INSURED_AMT) {
          insuredAmtVal = insuredAmtOpts.filter(item => +item.VALUE === +insured.INSURED_AMT).length ?? 0 > 0 ? insured.INSURED_AMT : '';
        };
        // 如果原本無值，嘗試帶入試算頁選擇金額
        if (!insured.INSURED_AMT && isFirstInsured) {
          insuredAmtVal = !isUnder15
            ? insuredAmtOpts.filter(item => +item.VALUE === +this.props.tempCalcFormVal.OVER15_AMOUNT).length ?? 0 > 0 ? this.props.tempCalcFormVal.OVER15_AMOUNT : ''
            : insuredAmtOpts.filter(item => +item.VALUE === +this.props.tempCalcFormVal.UNDER15_AMOUNT).length ?? 0 > 0 ? this.props.tempCalcFormVal.UNDER15_AMOUNT : '';
        }
      }
      // 如不是第一被保人，嘗試帶入第一被保人的值
      if (!isFirstInsured && firstInsured) {
        insuredAmtVal = insuredAmtOpts.filter(item => +item.VALUE === +firstInsured.INSURED_AMT).length ?? 0 > 0 ? firstInsured.INSURED_AMT : '';
      }

      const insuredAmtText = insuredAmtOpts.find((item) => +item.VALUE === +insuredAmtVal)?.TEXT;

      setFieldValue(`INSUREDS[${index}].INSURED_AMT_OPTS`, insuredAmtOptRes);
      setFieldValue(`INSUREDS[${index}].INSURED_AMT`, insuredAmtVal);
      setFieldValue(`INSUREDS[${index}].INSURED_MFUNERAL`, String(this.props.tempCalcFormVal.MFUNERAL));
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_VALUE`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_AGE_LIMIT_AMT`, this.handleAgeLimitAmt(insuredAge));
      setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, false);
      setFieldValue(`INSUREDS[${index}].INSURED_IS_UNDER15`, isUnder15);

      // 判斷被保人投保年齡是否大於 80
      const ageError = !this.hasAgeLimitAmt(insuredAge);
      if (ageError) {
        this.handleShowErrorMsg(CodeId.W006);
        this.handleResetInsuredCalcInfo(index, insureds, setFieldValue, insured.INSURED_ID_ERROR, true);
        return;
      }

      if (insuredAmtVal && insuredAmtText) {
        const insuredsCombined = _.cloneDeep(insureds);
        insuredsCombined[index].INSURED_AMT_OPTS = insuredAmtOptRes;
        insuredsCombined[index].INSURED_AMT = insuredAmtVal;
        insuredsCombined[index].INSURED_MEDICAL = '';
        insuredsCombined[index].INSURED_MEDICAL_VALUE = '';
        insuredsCombined[index].INSURED_AGE_LIMIT_AMT = this.handleAgeLimitAmt(insuredAge);
        insuredsCombined[index].INSURED_BIRTHDAY = birthdayVal;
        insuredsCombined[index].INSURED_BIRTHDAY_ERROR = false;
        this.handleSetMedicalAmt(index, insuredAmtVal, insuredAmtText, insuredsCombined);
      }
      const targetInsured = insureds.splice(index, 1)[0];
      if (targetInsured.INSURED_CALC) {
        targetInsured.INSURED_CALC = '';
        setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
        insureds.splice(index, 0, targetInsured);
        planData = this.handleUpdatePlandata(insureds);
        this.setState({ planData: planData });
      }
    }

    /**
     * @description 清除被保人的投保金額
    */
    handleResetInsuredCalcInfo = (index: number, insureds: InsuredState[], setFieldValue: any, idError: boolean, ageError: boolean) => {
      let planData = { ...this.state.planData } as EvalExpans;
      const targetInsureds = insureds.splice(index, 1)[0];

      // 檢核失敗，移除當筆的投保資訊金額與人數
      if (targetInsureds.INSURED_CALC) {
        setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
        targetInsureds.INSURED_CALC = '';
        insureds.splice(index, 0, targetInsureds);
        planData = this.handleUpdatePlandata(insureds);
      }

      setFieldValue(`INSUREDS[${index}].INSURED_AMT`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_VALUE`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_ID_ERROR`, idError);
      setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, ageError);

      this.setState({ planData: planData });
    }

    /**
     * @description 取得實支實付醫療顯示值
    */
    handleGetMedical = (insuredAmtOpts: any, insuredAmt: string) => {
      if (insuredAmtOpts) {
        const lifeContent: LifeContent = _.find(insuredAmtOpts.OPTIONS.LIFE, (opt: LifeContent, index: number) => {
          return +opt.VALUE === +insuredAmt;
        });
        if (lifeContent && lifeContent.MEDICAL && lifeContent.MEDICAL.length > 0) {
          return lifeContent.MEDICAL[0];
        }
      }
    }

    /**
     * @description 設定實支實付欄位值
    */
    handleSetMfuneral = (index: number, insuredFuneralVal: string, insureds: InsuredState[]) => {
      if (!this.formikRef || !this.formikRef.current) return;
      const newInsureds = [...insureds];
      const targetInsured = newInsureds.splice(index, 1)[0];
      targetInsured.INSURED_MFUNERAL = +insuredFuneralVal;
      newInsureds.splice(index, 0, targetInsured);
      const insuredAmtVal = this.formikRef.current.values.INSUREDS[index].INSURED_AMT;
      this.handleSetInsuredCalcByAmtChange(index, newInsureds, insuredAmtVal);
    }

    /**
     * @description 設定實支實付欄位值
    */
    handleSetMedicalAmt = async (index: number, insuredAmtVal: string, insuredAmtText: string, insureds: InsuredState[]) => {
      if (!this.formikRef || !this.formikRef.current) return;
      const setFieldValue = this.formikRef.current.setFieldValue;
      const insured = { ...insureds[index] };
      const insuredAmtOpts = { ...insured.INSURED_AMT_OPTS };
      const newInsureds = [...insureds];
      // 判斷是否小於 15 歲
      const insuredAge = await this.handleGetInsuredAge(insured.INSURED_BIRTHDAY);
      const isUnder15 = insuredAge < 15;
      if (!insuredAmtOpts || Object.keys(insuredAmtOpts).length === 0) return;
      // 若無失能保額值，清空實支實付、投保金額等欄位值
      if (!insuredAmtVal || +insuredAmtVal > insured.INSURED_AGE_LIMIT_AMT) {
        insureds.forEach((insured, i) => {
          if (insured.INSURED_IS_UNDER15 === isUnder15) {
            setFieldValue(`INSUREDS[${i}].INSURED_AMT`, '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL`, '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL_VALUE`, '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL_NAME`, '');
          }
        });

        const targetInsured = newInsureds.splice(index, 1)[0];
        // 有投保金額，執行刪除，清空投保金額欄位
        if (targetInsured.INSURED_CALC) {
          targetInsured.INSURED_CALC = '';
          setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
          newInsureds.splice(index, 0, targetInsured);
          let planData: any = { ...this.state.planData };
          planData = this.handleUpdatePlandata(newInsureds);
          this.setState({ planData: planData });
        }

        return;
      }
      const medical = this.handleGetMedical(insuredAmtOpts, insuredAmtVal);
      const medicalText = medical ? commonService.handleConvertAmount(medical.VALUE) : '';
      const medicalVal = medical ? medical.VALUE : '';
      const targetInsured = newInsureds.splice(index, 1)[0];
      const firstInsured = insureds.filter(item => item.INSURED_IS_UNDER15 === isUnder15)[0];
      const firstInsuredIndex = insureds.indexOf(firstInsured);
      if (index !== firstInsuredIndex && firstInsured) {
        const isHaveOpts = insureds[index].INSURED_AMT_OPTS.OPTIONS.LIFE.filter((item: any) => +item.VALUE === +firstInsured.INSURED_AMT).length ?? 0 > 0;
        setFieldValue(`INSUREDS[${index}].INSURED_AMT`, isHaveOpts ? firstInsured.INSURED_AMT : '');
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, isHaveOpts ? firstInsured.INSURED_MEDICAL : '');
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_VALUE`, isHaveOpts ? firstInsured.INSURED_MEDICAL_VALUE : '');
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_NAME`, isHaveOpts ? firstInsured.INSURED_MEDICAL_NAME : '');
        setFieldValue(`INSUREDS[${index}].INSURED_AMT_NAME`, isHaveOpts ? firstInsured.INSURED_AMT_NAME : '');
        targetInsured.INSURED_AMT = isHaveOpts ? firstInsured.INSURED_AMT : '';
        targetInsured.INSURED_MEDICAL = isHaveOpts ? firstInsured.INSURED_MEDICAL : '';
        targetInsured.INSURED_MEDICAL_VALUE = isHaveOpts ? firstInsured.INSURED_MEDICAL_VALUE : '';
        targetInsured.INSURED_MEDICAL_NAME = isHaveOpts ? firstInsured.INSURED_AMT_NAME : '';
      } else {
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, medicalText);
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_VALUE`, medicalVal);
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_NAME`, medicalText);
        setFieldValue(`INSUREDS[${index}].INSURED_AMT_NAME`, insuredAmtText);
        insureds.forEach((item, i) => {
          if (item.INSURED_IS_UNDER15 === isUnder15 && item.INSURED_AMT_OPTS?.OPTIONS?.LIFE) {
            const isHaveOpts = item.INSURED_AMT_OPTS.OPTIONS.LIFE.filter((item: any) => +item.VALUE === +insuredAmtVal).length ?? 0 > 0;
            setFieldValue(`INSUREDS[${i}].INSURED_AMT`, isHaveOpts ? insuredAmtVal : '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL`, isHaveOpts ? medicalText : '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL_VALUE`, isHaveOpts ? medicalVal : '');
            setFieldValue(`INSUREDS[${i}].INSURED_MEDICAL_NAME`, isHaveOpts ? medicalText : '');
            setFieldValue(`INSUREDS[${i}].INSURED_AMT_NAME`, isHaveOpts ? insuredAmtText : '');
          }
        });
        targetInsured.INSURED_AMT = insuredAmtVal;
        targetInsured.INSURED_MEDICAL = medicalText;
        targetInsured.INSURED_MEDICAL_VALUE = medicalVal;
        targetInsured.INSURED_MEDICAL_NAME = medicalText;
      }

      newInsureds.splice(index, 0, targetInsured);
      this.handleSetInsuredCalcByAmtChange(index, newInsureds, insuredAmtVal);
    }

    /**
     * @description 取得保費計算結果，並更新資料，於被保險人區塊 身份證、身故失能保額欄位事件使用
    */
    handleSetInsuredCalcByAmtChange = async (index: number, insureds: InsuredState[], insuredAmt: any) => {
      if (!this.formikRef || !this.formikRef.current) return;
      const setFieldValue = this.formikRef.current.setFieldValue;
      const tragetInsured = insureds.splice(index, 1)[0];
      const res: any = await this.handleFetchCalcRes(
        tragetInsured.INSURED_ID,
        tragetInsured.INSURED_BIRTHDAY,
        tragetInsured.INSURED_AMT,
        tragetInsured.INSURED_AMT_OPTS,
        String(tragetInsured.INSURED_MFUNERAL)
      );
      if (res && typeof res !== 'string') {
        const insuredAge = await this.handleGetInsuredAge(tragetInsured.INSURED_BIRTHDAY);
        // 判斷是否小於 15 歲
        const isUnder15 = insuredAge < 15;
        if (!isUnder15 || this.formikRef.current.values.INSUREDS[index].INSURED_MFUNERAL !== 0) {
          insureds.forEach((item) => {
            if (isUnder15 === item.INSURED_IS_UNDER15) {
              item.INSURED_CALC = res.DATA[0].FEE;
            }
          });
          this.formikRef.current.values.INSUREDS.forEach((item: any, index: number) => {
            if (isUnder15 === item.INSURED_IS_UNDER15 && item.INSURED_AMT_OPTS?.OPTIONS) {
              const insuredAmt = item.INSURED_AMT_OPTS.OPTIONS.LIFE.filter((item: any) => +item.VALUE === +tragetInsured.INSURED_AMT).length ?? 0 > 0 ? tragetInsured.INSURED_AMT : '';
              if (tragetInsured.INSURED_AMT) setFieldValue(`INSUREDS[${index}].INSURED_AMT`, insuredAmt);
              if (insuredAmt) setFieldValue(`INSUREDS[${index}].INSURED_CALC`, res.DATA[0].FEE);
              if (!insuredAmt) setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
            }
          });
        } else {
          let firstUnder15Index: number = -1;
          this.formikRef.current.values.INSUREDS.forEach((item: any, index: number) => {
            if (firstUnder15Index !== -1) {
              setFieldValue(`INSUREDS[${index}].INSURED_MFUNERAL`, this.formikRef.current.values.INSUREDS[firstUnder15Index].INSURED_MFUNERAL);
              setFieldValue(`INSUREDS[${index}].INSURED_CALC`, this.formikRef.current.values.INSUREDS[firstUnder15Index].INSURED_CALC);
            }
            if (item.INSURED_IS_UNDER15) firstUnder15Index = index;
          });
        }
        setFieldValue(`INSUREDS[${index}].INSURED_CONTRACT_AGE`, insuredAge);
        setFieldValue(`INSUREDS[${index}].INSURED_IS_UNDER15`, isUnder15);
        if (tragetInsured.INSURED_MFUNERAL !== 0) {
          setFieldValue(`INSUREDS[${index}].INSURED_CALC`, res.DATA[0].FEE);
        }
        tragetInsured.INSURED_CALC = res.DATA[0].FEE;
        tragetInsured.INSURED_CONTRACT_AGE = insuredAge;
        tragetInsured.INSURED_IS_UNDER15 = isUnder15;

        insureds.splice(index, 0, tragetInsured);

        const planData = this.handleUpdatePlandata(insureds);

        this.setState({ planData: planData });
      } else {
        setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
      }
    }

    // #endregion

    // #region OK 要保人同步被保人相關方法

    /**
      * @description 判斷是否同步設定第一被保人資料，在多人投保且對象為親屬時，僅同步關係為本人的資料
     */
    handleSetInsuredVal = async (fieldName: string, val: any, formVal: IFill2ndFormValue) => {
      if (!this.state.isInitFirstInsured) return;

      // 取得被保險人，關係為本人的卡片位置
      const targetIndex = this.handleGetSelfIndex(formVal);
      // 無本人就不設值
      if (targetIndex === -1) return;

      this.formikRef.current.setFieldValue(`INSUREDS[${targetIndex}].${fieldName}`, val);
    }

    /**
     * @description 取得被保人-關係為本人的 index
    */
    handleGetSelfIndex = (values: IFill2ndFormValue) => {
      const insureds = [...values.INSUREDS];
      return _.findIndex(insureds, (insured: InsuredState) => insured.INSURED_RELATION === InsuredRelation.Self);
    }

    /**
       * @description 檢核生日日期
      */
    handleValidBirthday = async (val: any, formVal: IFill2ndFormValue) => {
      if (!val) return;

      const insuredAge = await this.handleGetInsuredAge(val);
      const actualAge = await this.handleGetActualAge(val);
      const policyAgeLimit = this.getPolicyAgeLimit(this.props.tempCalcFormVal.PROD_ID);
      if (!policyAgeLimit) throw new Error('無法取得要保人年齡限制');

      // < 7 歲，則提示訊息：親愛的客戶您好，要保人須年滿7歲，不得繼續。
      // if (age < 7) {
      //   this.handleShowErrorMsg(CodeId.W003);
      //   this.handleRequriedAgeLimit();
      //   this.setState({ birthdayErrMsg: '要保人須年滿7歲' });
      //   this.formikRef.current.setFieldError('BIRTHDAY', '要保人須年滿7歲');
      //   this.formikRef.current.setFieldTouched('BIRTHDAY', true);
      //   return;
      // }

      // < 18 歲，則提示訊息: 親愛的客戶您好，要保人須年滿18歲，不得繼續。
      if (actualAge < +policyAgeLimit) {
        this.handleShowErrorMsg(CodeId.W088);
        this.handleRequriedAgeLimit();
        this.setState({ birthdayErrMsg: '要保人須年滿18歲' });
        this.formikRef.current.setFieldError('BIRTHDAY', '要保人須年滿18歲');
        this.formikRef.current.setFieldTouched('BIRTHDAY', true);
        return;
      }

      // 年齡大於 80 且投保對象不為親屬時，提示檢核且不能繼續
      if (!this.hasAgeLimitAmt(insuredAge) && this.state.insureSubject?.PARAM_VALUE !== InsureSubject.Relatives) {
        this.handleShowErrorMsg(CodeId.W006);
        this.handleRequriedAgeLimit();
        return;
      }

      // > 7 且 <= 17 歲，則提示訊息：親愛的客戶您好，要保人未滿18歲，投保時要保書須法定代理人簽名，僅提示可繼續投保。
      // if (age <= 17) {
      //   this.handleShowErrorMsg(CodeId.W004);
      // }

      // 若 通過檢核 且 為年齡限制，設限制為 false
      if (this.state.isAgeLimit) {
        this.setState({ isAgeLimit: false });
      }

      this.setState({ birthdayErrMsg: '' });
      this.formikRef.current.setFieldError('BIRTHDAY', '');
      this.formikRef.current.setFieldTouched('BIRTHDAY', true);
      // 需同步第一被保人且通過前面年齡檢核時進行保費計算
      await this.handleSetSelfCalcInfoByIdAndBirthday(formVal.MEMBER_ID, val, formVal);
    }

    /**
     * @description 要保人年齡檢核錯誤提示訊息，並不得繼續
    */
    handleRequriedAgeLimit = () => {
      const setFieldValue = this.formikRef.current.setFieldValue;

      setFieldValue('KYCINFOS', this.handleGetKycInfos(this.combineKycCondition()));

      this.setState({
        isAgeLimit: true
      });
    }

    /**
     * @description 組合 KYC 相依條件
     */
    combineKycCondition = () => {
      const tempCalcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue;
      const { INS_COUNT, INSURED_SUBJECT, OVER15_COUNT, UNDER15_COUNT } = tempCalcFormVal;
      const insCount = INS_COUNT as InsCount;
      const cond: KYC_INIT_CONDITION = {
        INS_COUNT: insCount,
        INSURED_SUBJECT,
        OVER15_COUNT,
        UNDER15_COUNT
      };
      return cond;
    }

    /**
     * @description 判斷被保人是否重複選取 本人
     * @param index 卡片 index
     * @param relation 選取的關係
     * @param insureds 被保人資料集
    */
    handleValidSelfRelation = (index: number, relation: string, insureds: InsuredState[]) => {
      let errorMsg = '';
      let repeat = relation === InsuredRelation.Self &&
            _.some(insureds, (insured: InsuredState, i) => insured.INSURED_RELATION === InsuredRelation.Self && i !== index);

      if (repeat) errorMsg = '關係本人,已重覆';

      repeat = relation === InsuredRelation.Spouse &&
            _.some(insureds, (insured: InsuredState) => insured.INSURED_RELATION === InsuredRelation.Spouse);

      if (repeat) errorMsg = '關係配偶,已重覆';

      if (errorMsg) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: errorMsg
        });

        const targetInsured = insureds.splice(index, 1)[0];
        targetInsured.INSURED_RELATION = '';
        targetInsured.INSURED_RELATION_NAME = '';
        insureds.splice(index, 0, targetInsured);

        this.formikRef.current.setFieldValue('INSUREDS', insureds);
      }

      return errorMsg;
    }

    /**
      * @description 被保險人-與要保人關係欄位變更時判斷是否重複設定本人，在多人投保、對象為親屬時，選取本人時帶入要本人資料
     */
    handleInsuredRelationChange = async (value: string, index: number, formVal: IFill2ndFormValue) => {
      const setFieldValue = this.formikRef.current.setFieldValue;
      const name = this.handleGetRelationName(this.state.relationSysOpts, value);

      commonService.setSelectOptName(setFieldValue, `INSUREDS[${index}].INSURED_RELATION_NAME`, name);

      const insureds = [...formVal.INSUREDS];

      // 檢核是否重複選取 本人
      if (this.handleValidSelfRelation(index, value, insureds)) return;

      // 選取關係為非本人時
      if (value !== InsuredRelation.Self) {
        const targetInsured = insureds.splice(index, 1)[0];
        // 判斷原關係是否為本人，是則清空資料
        if (targetInsured.INSURED_RELATION === InsuredRelation.Self || !targetInsured.INSURED_RELATION) {
          setFieldValue(`INSUREDS[${index}].INSURED_ID`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_MOBILE`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_EMAIL_ADDR`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_NAME`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_AMT`, '');
          setFieldValue(`INSUREDS[${index}].INSURED_AMT_OPTS`, '');
          if (targetInsured.INSURED_CALC) {
            let planData: any = { ...this.state.planData };

            setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
            targetInsured.INSURED_CALC = '';
            insureds.splice(index, 0, targetInsured);

            planData = this.handleUpdatePlandata(insureds);
            this.setState({ planData: planData });
          }
        }
        return;
      }

      // 投保人數為多人、關係為親屬、被保人關係選取本人時代入要本人資料
      const isSetSelf =
        // this.state.insCount === InsCount.MORE &&
        // this.state.insureSubject?.PARAM_VALUE === InsureSubject.Relatives &&
        value === InsuredRelation.Self;
      if (!isSetSelf) return;

      setFieldValue(`INSUREDS[${index}].INSURED_ID`, formVal.MEMBER_ID);
      setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, formVal.BIRTHDAY);
      setFieldValue(`INSUREDS[${index}].INSURED_MOBILE`, formVal.MOBILE);
      setFieldValue(`INSUREDS[${index}].INSURED_EMAIL_ADDR`, formVal.EMAIL_ADDR);
      setFieldValue(`INSUREDS[${index}].INSURED_NAME`, formVal.NAME);
      this.handleCheckInsuredBirthdayThroughInsuredRelation(moment(formVal.BIRTHDAY, 'YYYY/MM/DD'), index);
      if (formVal.MEMBER_ID && formVal.BIRTHDAY) {
        await this.handleSetSelfCalcInfoByRelation(formVal, index);
      } else {
        setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_AMT`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_AMT_OPTS`, '');

        const targetInsured = insureds.splice(index, 1)[0];
        if (targetInsured.INSURED_CALC) {
          let planData: any = { ...this.state.planData };
          targetInsured.INSURED_CALC = '';
          setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
          insureds.splice(index, 0, targetInsured);

          planData = this.handleUpdatePlandata(insureds);
          this.setState({ planData: planData });
        }
      }
    }

    /**
     * @description 取得與要保人關係名稱
    */
    handleGetRelationName = (relationSysOpts: SysOption[], relationVal: string) => {
      return commonService.getSysOptText(relationSysOpts, relationVal) || '';
    }

    /**
      * @description 設定第一被保人試算金額(要保人 身份證、生日欄位事件使用)
     */
    handleSetSelfCalcInfoByRelation = async (formVal: IFill2ndFormValue, selfIndex: number) => {
      const memberId = formVal.MEMBER_ID;
      const birthdayVal = formVal.BIRTHDAY;

      // 有要本人生日，進行年齡檢核
      const insuredAge = await this.handleGetInsuredAge(birthdayVal);
      const ageError = !this.hasAgeLimitAmt(insuredAge);
      if (ageError) {
        this.handleShowErrorMsg(CodeId.W006);
        this.handleResetCalcInfo(selfIndex, ageError);
        return;
      }
      await this.handleUpdateCalcInfo(formVal, selfIndex, memberId, birthdayVal, insuredAge, false);
    }

    /**
     * @description 設定第一被保人試算金額(要保人 身份證、生日欄位事件使用)
     */
    handleSetSelfCalcInfoByIdAndBirthday = async (memberId: string, birthdayVal: any, formVal: IFill2ndFormValue, isIdChange: boolean = false) => {
      const selfIndex = this.handleGetSelfIndex(formVal);

      if (selfIndex === -1 || !memberId || !birthdayVal) return;

      if (!this.state.isInitFirstInsured || (isIdChange && formVal.INSUREDS[selfIndex].INSURED_CALC)) return;

      // 有要本人生日，進行年齡檢核
      const insuredAge = await this.handleGetInsuredAge(birthdayVal);
      const ageError = !this.hasAgeLimitAmt(insuredAge);
      if (ageError) {
        this.handleShowErrorMsg(CodeId.W006);
        this.handleResetCalcInfo(selfIndex, ageError);
        return;
      }
      await this.handleUpdateCalcInfo(formVal, selfIndex, memberId, birthdayVal, insuredAge);
    }

    /**
     * @description 更新被保人身故失能保額、實支實付醫療、投保金額等資訊
     */
    handleUpdateCalcInfo = async (formVal: IFill2ndFormValue, selfIndex: number, memberId: string, birthdayVal: any, age: number, isNotRelationChange: boolean = true) => {
      const insureds = [...formVal.INSUREDS];
      // 取得被保人關係為本人的卡片資料
      const selfInsured = insureds.splice(selfIndex, 1)[0];

      let planData: any = { ...this.state.planData };
      const setFieldValue = this.formikRef.current.setFieldValue;

      // 若被保人-本人已有投保金額，先刪除投保金額，更新計算投保資訊
      if (selfInsured && selfInsured.INSURED_CALC) {
        selfInsured.INSURED_CALC = '';
        setFieldValue(`INSUREDS[${selfIndex}].INSURED_CALC`, '');
        insureds.splice(selfIndex, 0, selfInsured);

        planData = this.handleUpdatePlandata(insureds);
      }

      const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue; // { ...this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal };
      const birthday = moment(birthdayVal).format('YYYYMMDD');

      // 取得投保方案起始日
      const contractDate = moment(calcFormVal.START_DATE).format('YYYYMMDD');

      // 取得失能保額清單值
      const insuredAmtOptRes = await service.fetchInsuredAmtOpt(planData.INS_TYPE_ID, planData.PROD_ID, planData.HEADER.PLAN_ID, birthday, contractDate);

      const isUnder15 = age < 15; // 判斷是否小於 15 歲
      const insuredAmtOpts = insuredAmtOptRes ? _.cloneDeep(insuredAmtOptRes.OPTIONS.LIFE) : [];
      const insuredAmtVal = !isUnder15
        ? insuredAmtOpts.filter(item => +item.VALUE === +this.props.tempCalcFormVal.OVER15_AMOUNT).length ?? 0 > 0 ? this.props.tempCalcFormVal.OVER15_AMOUNT : ''
        : insuredAmtOpts.filter(item => +item.VALUE === +this.props.tempCalcFormVal.UNDER15_AMOUNT).length ?? 0 > 0 ? this.props.tempCalcFormVal.UNDER15_AMOUNT : '';
      const insuredAmtText = insuredAmtOpts.find((item) => +item.VALUE === +insuredAmtVal)?.TEXT;
      if (isNotRelationChange) {
        setFieldValue(`INSUREDS[${selfIndex}].INSURED_RELATION`, InsuredRelation.Self);
        setFieldValue(`INSUREDS[${selfIndex}].INSURED_RELATION_NAME`, this.handleGetRelationName(this.state.relationSysOpts, InsuredRelation.Self));
      }
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_CONTRACT_AGE`, age);
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_IS_UNDER15`, age < 15);
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_AMT`, insuredAmtVal);
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_AMT_NAME`, '');
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_AMT_OPTS`, { ...insuredAmtOptRes });
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_AGE_LIMIT_AMT`, this.handleAgeLimitAmt(age));
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_MEDICAL`, '');
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_MEDICAL_VALUE`, '');
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_MEDICAL_NAME`, '');
      setFieldValue(`INSUREDS[${selfIndex}].INSURED_BIRTHDAY_ERROR`, false);

      if (insuredAmtVal && insuredAmtText) {
        const insuredsCombined = _.cloneDeep(formVal.INSUREDS);
        insuredsCombined[selfIndex].INSURED_ID = memberId;
        insuredsCombined[selfIndex].INSURED_AMT_OPTS = insuredAmtOptRes;
        insuredsCombined[selfIndex].INSURED_AMT = insuredAmtVal;
        insuredsCombined[selfIndex].INSURED_MEDICAL = '';
        insuredsCombined[selfIndex].INSURED_MEDICAL_VALUE = '';
        insuredsCombined[selfIndex].INSURED_AGE_LIMIT_AMT = this.handleAgeLimitAmt(age);
        insuredsCombined[selfIndex].INSURED_BIRTHDAY = birthdayVal;
        insuredsCombined[selfIndex].INSURED_BIRTHDAY_ERROR = false;
        this.handleSetMedicalAmt(selfIndex, insuredAmtVal, insuredAmtText, insuredsCombined);
      }

      this.setState({ planData: planData });
    }

    /**
     * @description 清除被保人的身故失能保額、實支實付醫療、投保金額等資訊
    */
    handleResetCalcInfo = (index: number, ageError: boolean) => {
      const formVal = this.formikRef.current.values as IFill2ndFormValue;
      const insureds = [...formVal.INSUREDS];

      let planData = { ...this.state.planData } as EvalExpans;
      const targetInsureds = insureds.splice(index, 1)[0];
      const setFieldValue = this.formikRef.current.setFieldValue;
      // 檢核失敗，移除當筆的投保資訊金額與人數
      if (targetInsureds.INSURED_CALC) {
        targetInsureds.INSURED_CALC = '';
        setFieldValue(`INSUREDS[${index}].INSURED_CALC`, '');
        insureds.splice(index, 0, targetInsureds);
        planData = this.handleUpdatePlandata(insureds);
      }
      setFieldValue(`INSUREDS[${index}].INSURED_AMT`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_MEDICAL_VALUE`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY_ERROR`, ageError);

      this.setState({ planData: planData });
    }

    // #endregion

    // #region OK 投保金額試算相關

    /**
     * @description 依被保人資料更新 planData
    */
    handleUpdatePlandata = (insureds: InsuredState[], oldPlanData?: EvalExpans) => {
      // 取得被保人 15 歲上、下的卡片陣列資料
      const over15Insureds = _.filter(insureds, (insured: InsuredState) => !insured.INSURED_IS_UNDER15 && +insured.INSURED_CALC > 0);
      const under15Insureds = _.filter(insureds, (insured: InsuredState) => insured.INSURED_IS_UNDER15 && +insured.INSURED_CALC > 0);

      // 加總 15 歲上下各自的投保金額
      const over15Fee = _.reduce(
        _.map(over15Insureds, (insured: InsuredState) => insured.INSURED_CALC ? +insured.INSURED_CALC : 0),
        (prev: number, curr: number) => {
          return prev + curr;
        }, 0);
      const under15Fee = _.reduce(
        _.map(under15Insureds, (insured: InsuredState) => insured.INSURED_CALC ? +insured.INSURED_CALC : 0),
        (prev: number, curr: number) => {
          return prev + curr;
        }, 0);

      // 總投保金額 = 15 歲上下各自的投保金額總和
      const total = over15Fee + under15Fee;
      let planData = oldPlanData ? { ...oldPlanData } : { ...this.state.planData } as EvalExpans;

      // 更新投保資訊 Footer Total
      const footerDatas = _.map(planData.FOOTER, (footerData: ExpanFooterContent) => {
        let newFooterData = { ...footerData };
        if (footerData.TITLE.startsWith('15歲以上')) {
          newFooterData = {
            TITLE: footerData.TITLE.replace(/(.*)\(([\d]{0,})(.*)\)/, `$1(${over15Insureds.length}$3)`),
            TOTAL: `NT$ ${over15Fee} 元`
          };
        }

        if (footerData.TITLE.startsWith('15歲以下')) {
          newFooterData = {
            TITLE: footerData.TITLE.replace(/(.*)\(([\d]{0,})(.*)\)/, `$1(${under15Insureds.length}$3)`),
            TOTAL: `NT$ ${under15Fee} 元`
          };
        }

        if (footerData.TITLE.startsWith('保費合計')) {
          newFooterData = {
            ...footerData,
            TOTAL: `NT$ ${total} 元`
          };
        }
        return newFooterData;
      });

      planData = {
        ...planData,
        HEADER: {
          ...planData.HEADER,
          TOTAL: `${total}`
        },
        FOOTER: footerDatas
      };

      return planData;
    }

    /**
    * @description 依年齡取得投保上限用
    */
    handleAgeLimitAmt = (age: number) => {
      if (!this.props.ageLimitcnd) return 0;

      if (age <= this.props.ageLimitcnd.INS_AGE_CEILING_1) return this.props.ageLimitcnd.AMOUNT_1;
      if (age <= this.props.ageLimitcnd.INS_AGE_CEILING_2) return this.props.ageLimitcnd.AMOUNT_2;
      if (age <= this.props.ageLimitcnd.INS_AGE_CEILING_3) return this.props.ageLimitcnd.AMOUNT_3;
      if (age <= this.props.ageLimitcnd.INS_AGE_CEILING_4) return this.props.ageLimitcnd.AMOUNT_4;

      return 0;
    }

    /**
    * @description 依年齡判斷是否可投保
    */
    hasAgeLimitAmt = (age: number) => {
      let res;
      if (this.props.ageLimitcnd) {
        if (age >= this.props.ageLimitcnd.INS_AGE_FLOOR_1 && age < this.props.ageLimitcnd.INS_AGE_FLOOR_2) {
          res = this.props.ageLimitcnd.AMOUNT_1;
        }

        if (age >= this.props.ageLimitcnd.INS_AGE_FLOOR_2 && age < this.props.ageLimitcnd.INS_AGE_FLOOR_3) {
          res = this.props.ageLimitcnd.AMOUNT_2;
        }

        if (age >= this.props.ageLimitcnd.INS_AGE_FLOOR_3 && age < this.props.ageLimitcnd.INS_AGE_FLOOR_4) {
          res = this.props.ageLimitcnd.AMOUNT_3;
        }

        if (age >= this.props.ageLimitcnd.INS_AGE_FLOOR_4 && age <= this.props.ageLimitcnd.INS_AGE_CEILING_4) {
          res = this.props.ageLimitcnd.AMOUNT_4;
        }
      }
      return res && res > 0;
    }

    /**
      * @description 取得被保險人物件流水號、被保險人 ID 、 生日 、 失能保額等欄位值進行保費計算
     */
    handleFetchCalcRes = async (
      insuredId: string, insuredBirthday: any,
      insuredAmt: string, insuredAmtOpts: any,
      insuredFuneral: string
    ) => {
      if (insuredId && insuredBirthday && insuredAmt && insuredAmtOpts) {
        // 取得實支實付投保值、建立投保人資料
        const medical = this.handleGetMedical(insuredAmtOpts, insuredAmt);

        if (!medical) return;

        const dataReqContent: DATAReqContent = {
          ID: insuredId,
          BIRTHDAY: moment(insuredBirthday).format('YYYYMMDD'),
          LIFE: +insuredAmt,
          MEDICAL: +medical.VALUE,
          MFUNERAL: +insuredFuneral
        };

        const planData = { ...this.state.planData } as EvalExpans;
        const calcFormVal = { ...this.props.tempCalc.tempCalcFormVal } as ICalcFormValue; // { ...this.props.tempFill1st.tempFill1stState.editedTempCalc.tempCalcFormVal };

        // 建立保費計算用 Request Model
        const policyReq: PolicyFeeReq = {
          INS_TYPE_ID: planData.INS_TYPE_ID,
          PROD_ID: planData.PROD_ID,
          PLAN_ID: planData.HEADER.PLAN_ID,
          CLASS: '1',
          START_DATE: moment(calcFormVal.START_DATE).format('YYYYMMDD'),
          END_DATE: moment(calcFormVal.END_DATE).format('YYYYMMDD'),
          DATA: [{ ...dataReqContent }]
        };
        return await service.fetchPolocyFee(policyReq);
      }
    }

    // #endregion

    handleGetProgramDetailsRefHeight = () => {
      if (this.programDetailsRef && this.programDetailsRef.current) return this.programDetailsRef.current!.clientHeight;

      return 0;
    }

    handleGetSubTotalO15 = () => {
      // if (this.props.tempCalc.evalReq?.OVER15_COUNT === '') return 0;
      const formVal = this.formikRef.current;
      let sum = 0;
      if (formVal) {
        const insureds = formVal.values.INSUREDS;
        sum = insureds.filter((item: any) => item.INSURED_IS_UNDER15 === false).reduce((acc: any, current: any) => acc + parseInt(current.INSURED_CALC === '' ? '0' : current.INSURED_CALC), 0);
      }
      return sum;
    }

    handleGetSubTotalU15 = () => {
      // if (this.props.tempCalc.evalReq?.UNDER15_COUNT === '') return 0;
      const formVal = this.formikRef.current;
      let sum = 0;
      if (formVal) {
        const insureds = formVal.values.INSUREDS;
        sum = insureds.filter((item: any) => item.INSURED_IS_UNDER15 === true).reduce((acc: any, current: any) => acc + parseInt(current.INSURED_CALC === '' ? '0' : current.INSURED_CALC), 0);
      }
      return sum;
    }

    handleViewToggle = () => {
      this.setState({ hidePolicyID: !this.state.hidePolicyID });
    };

    render () {
      const {
        programSummaryVisible,
        programSummaryDetailsOpen,
        programDetailsOpen
      } = this.state;
      const programSummaryClasses = ['program-summary'];
      const programSummaryDetailsElemHeight = programSummaryDetailsOpen ? 'calc(100vh - 335px)' : 0;
      const programDetailsElemHeight = programDetailsOpen ? '100%' : 0;

      if (programSummaryVisible) {
        programSummaryClasses.push('program-summary--active');
      }

      // #region  建立投保資訊區塊
      /**
        * @description 取得保險期間
       */
      const handleGetInsperiod = () => {
        const tempFill1stFormVal = { ...this.props.tempFill1st.tempFill1stFormVal } as IFill1stFormValue;
        const isFormatMsg = tempFill1stFormVal &&
                tempFill1stFormVal.START_DATE &&
                tempFill1stFormVal.END_DATE &&
                tempFill1stFormVal.INSURED_TIME &&
                tempFill1stFormVal.INSURE_PERIOD;
        // const startDate = moment(tempFill1stFormVal.START_DATE).format('YYYY-MM-DD 00:00:00');
        // const endDate = moment(tempFill1stFormVal.END_DATE).format('YYYY-MM-DD 00:00:00');
        // const period = moment(endDate).diff(moment(startDate), 'd');
        if (isFormatMsg) {
          return (
            <>
              <p>{moment(tempFill1stFormVal.START_DATE).format('YYYY/MM/DD')} {moment(tempFill1stFormVal.INSURED_TIME).format('HH')}:00 ~ {moment(tempFill1stFormVal.END_DATE).format('YYYY/MM/DD')} {moment(tempFill1stFormVal.INSURED_TIME).format('HH')}:00</p>
              <p>共投保 {moment(moment(tempFill1stFormVal.END_DATE).format('YYYY-MM-DD')).diff(moment(moment(tempFill1stFormVal.START_DATE).format('YYYY-MM-DD')), 'd')} 天</p>
            </>
          );
        }
        return '';
      };

      /**
        * @description 取得旅遊/活動地點組合後的顯示資訊
       */
      const handleGetTravelInfo = () => {
        if (!this.props.tempFill1st.tempFill1stState?.tempTravels) return '';

        return _.reduce(_.map(this.props.tempFill1st.tempFill1stState.tempTravels, (travels: TravelWarningExpandData) => travels.COUNTRY_NAME as string), (res: string, country: string) => {
          return `${res}、${country}`;
        });
      };

      /**
        * @description 切換 Fold 組件開啟/關閉
        * @param foldIndex 資料中使用 Fold 組件的 Row index
      */
      const handleFoldToggle = (foldIndex: number) => {
        const updatedPcDetailFoldsOpen = [...this.state.detailFoldsOpen];
        updatedPcDetailFoldsOpen[foldIndex] = !updatedPcDetailFoldsOpen[foldIndex];
        this.setState(prevState => {
          return {
            ...prevState,
            detailFoldsOpen: updatedPcDetailFoldsOpen
          };
        });
      };

      /**
       * @description 查看目標 身故失能保額 是否在滿 15 歲或未滿 15 歲陣列為第一筆
       */
      const handleCheckInsuredAmt = (index: number) => {
        if (this.formikRef.current) {
          const insureds = this.formikRef.current.values.INSUREDS;
          /** 目標是否為未滿 15 歲 */
          if (insureds[index]) {
            const targetIsUnder15 = insureds[index].INSURED_IS_UNDER15;
            if (targetIsUnder15) {
              /** 未滿 15 歲 被保險人 */
              const insuredsUnder15 = insureds.filter((item: any) => item.INSURED_IS_UNDER15 === true);
              return insuredsUnder15[0] !== insureds[index];
            } else {
              /** 滿 15 歲 被保險人 */
              const insuredsOver15 = insureds.filter((item: any) => item.INSURED_IS_UNDER15 === false);
              return insuredsOver15[0] !== insureds[index];
            }
          }
        }
      };

      /**
       * @description 查看 喪葬費用 是否在未滿 15 歲陣列為第一筆
       */
      const handleCheckInsuredAmtOpts = (index: number) => {
        if (this.formikRef.current) {
          const insureds = this.formikRef.current.values.INSUREDS;
          if (insureds[index]) {
            /** 未滿 15 歲 被保險人 */
            const insuredsUnder15 = insureds.filter((item: any) => item.INSURED_IS_UNDER15 === true);
            return insuredsUnder15[0] !== insureds[index];
          }
        }
      };

      /**
        * @description 旅遊資訊長度超過5字元格式化為 xxxxx...點選顯示完整資訊
        * @param travelInfoStr 旅遊/活動地點組合後的顯示資訊
      */
      const handleTravelInfoFormat = (travelInfoStr: string) => {
        if (!travelInfoStr) return;

        if (travelInfoStr && travelInfoStr.length <= 5) {
          return travelInfoStr;
        }

        return (
          <>
            {`${travelInfoStr.substring(0, 5)}`}
            <span
              className="element__link"
              onClick={() => {
                sweetAlertService.modal({
                  title: '旅遊/活動地點',
                  html: travelInfoStr
                });
              }}
            >...
            </span>
          </>
        );
      };

      const planDataContent: JSX.Element[] = [];
      if (this.state.planData) {
        const planData = { ...this.state.planData } as EvalExpans;
        if (planData.BODY_O15 && this.props.tempCalc.evalReq?.OVER15_COUNT !== '') {
          planDataContent.push(
            <div className="program-list__item" key="plan-title-O15">
              15歲以上投保方案
            </div>
          );
          _.forEach(planData.BODY_O15, (bodyContent: ExpanBodyContent, bodyContentIndex: number) => {
            switch (bodyContent.TYPE) {
              case EvalInfoBodyType.ROW:
                {
                  const insureds = [...this.formikRef.current.values.INSUREDS];
                  const hasOver15InsuredCalc = _.some(insureds, (insured: InsuredState) => insured.INSURED_CALC && !insured.INSURED_IS_UNDER15);
                  const hasUnder15InsuredCalc = _.some(insureds, (insured: InsuredState) => insured.INSURED_CALC && insured.INSURED_IS_UNDER15);
                  // 調整顯示文字
                  let rowFIELD = bodyContent.FIELD;
                  if (bodyContent.ROWTITLE.indexOf('意外死亡及失能') !== -1) {
                    rowFIELD = hasOver15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                  }

                  if (bodyContent.ROWTITLE.indexOf('意外失能(15歲以下)') !== -1) {
                    rowFIELD = hasUnder15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                  }

                  planDataContent.push(
                    <div className="program-details__table-tr" key={`row${bodyContentIndex}-O15`}>
                      <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                      <div className="program-details__table-td">{rowFIELD}</div>
                    </div>
                  );
                }
                break;
              case EvalInfoBodyType.FOLDABLE: {
                planDataContent.push(
                  <div className="program-details__table-tr" key={`foldable${bodyContentIndex}-O15`}>
                    <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                    <div className="program-details__table-td">
                      {
                        bodyContent.BODY && bodyContent.BODY?.length > 0 && (
                          <button
                            type="button"
                            className={'element__icon-button' + ((this.state.detailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add'))}
                            onClick={() => handleFoldToggle(bodyContentIndex)}
                          >
                            {this.state.detailFoldsOpen[bodyContentIndex] ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button>
                        )
                      }
                    </div>
                  </div>
                );
                const bodyChild = (
                  <div className="program-details__table-tr" key={`child${bodyContentIndex}-O15`}>
                    <ul className="program-details__items">
                      {
                        _.map(bodyContent.BODY, (bodyBaseContent: ExpanBodyBaseContent, bodyBaseContentIndex: number) => {
                          return (
                            <li key={bodyBaseContentIndex}>
                              <span>{bodyBaseContent.ROWTITLE}</span>
                              <span>{bodyBaseContent.FIELD}</span>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                );
                planDataContent.push(
                  <div className="premium-calc-list__body-foldable-content" key={`premium${bodyContentIndex}-O15`}>
                    <Fold isOpen={this.state.detailFoldsOpen[bodyContentIndex] as boolean}>
                      {bodyChild}
                    </Fold>
                  </div>
                );
                break;
              }
            }
          });
        }
        if (planData.SUBTOTAL_O15 && this.props.tempCalc.evalReq?.OVER15_COUNT !== '') {
          planDataContent.push(
            <div className="program-details__table-tr" key="subTotalO15">
              <div className="program-details__table-td">{planData.SUBTOTAL_O15[0].ROWTITLE}</div>
              <div className="program-details__table-td" style={{ color: '#FE3208' }}>{planData.SUBTOTAL_O15[0].FIELD}</div>
            </div>
          );
        }
        if (planData.BODY_U15 && this.props.tempCalc.evalReq?.UNDER15_COUNT !== '') {
          planDataContent.push(
            <div className="program-list__item" key="plan-title-U15">
              未滿15歲投保方案
            </div>
          );
          _.forEach(planData.BODY_U15, (bodyContent: ExpanBodyContent, bodyContentIndex: number) => {
            switch (bodyContent.TYPE) {
              case EvalInfoBodyType.ROW:
                {
                  const insureds = [...this.formikRef.current.values.INSUREDS];
                  const hasOver15InsuredCalc = _.some(insureds, (insured: InsuredState) => insured.INSURED_CALC && !insured.INSURED_IS_UNDER15);
                  const hasUnder15InsuredCalc = _.some(insureds, (insured: InsuredState) => insured.INSURED_CALC && insured.INSURED_IS_UNDER15);
                  // 調整顯示文字
                  let rowFIELD = bodyContent.FIELD;
                  if (bodyContent.ROWTITLE.indexOf('意外死亡及失能') !== -1) {
                    rowFIELD = hasOver15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                  }

                  if (bodyContent.ROWTITLE.indexOf('意外失能(15歲以下)') !== -1) {
                    rowFIELD = hasUnder15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                  }

                  planDataContent.push(
                    <div className="program-details__table-tr" key={`detail${bodyContentIndex}-U15`}>
                      <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                      <div className="program-details__table-td">{rowFIELD}</div>
                    </div>
                  );
                }
                break;
              case EvalInfoBodyType.FOLDABLE: {
                planDataContent.push(
                  <div className="program-details__table-tr" key={`foldable${bodyContentIndex}-U15`}>
                    <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                    <div className="program-details__table-td">
                      {
                        bodyContent.BODY && bodyContent.BODY?.length > 0 && (
                          <button
                            type="button"
                            className={'element__icon-button' + ((this.state.detailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add'))}
                            onClick={() => handleFoldToggle(bodyContentIndex)}
                          >
                            {this.state.detailFoldsOpen[bodyContentIndex] ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button>
                        )
                      }
                    </div>
                  </div>
                );
                const bodyChild = (
                  <div className="program-details__table-tr" key={`child${bodyContentIndex}-U15`}>
                    <ul className="program-details__items">
                      {
                        _.map(bodyContent.BODY, (bodyBaseContent: ExpanBodyBaseContent, bodyBaseContentIndex: number) => {
                          return (
                            <li key={bodyBaseContentIndex}>
                              <span>{bodyBaseContent.ROWTITLE}</span>
                              <span>{bodyBaseContent.FIELD}</span>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                );
                planDataContent.push(
                  <div className="premium-calc-list__body-foldable-content" key={`premium${bodyContentIndex}-U15`}>
                    <Fold isOpen={this.state.detailFoldsOpen[bodyContentIndex] as boolean}>
                      {bodyChild}
                    </Fold>
                  </div>
                );
                break;
              }
            }
          });
        }
        if (planData.SUBTOTAL_U15 && this.props.tempCalc.evalReq?.UNDER15_COUNT !== '') {
          planDataContent.push(
            <div className="program-details__table-tr" key="subTotalU15">
              <div className="program-details__table-td">{planData.SUBTOTAL_U15[0].ROWTITLE}</div>
              <div className="program-details__table-td" style={{ color: '#FE3208' }}>{planData.SUBTOTAL_U15[0].FIELD}</div>
            </div>
          );
        }
        _.forEach(planData.FOOTER, (footerContent: ExpanFooterContent, footerIndex: number) => {
          const total = commonService.thousandFormat(footerContent.TOTAL.replace(/.*\s([\d]{0,})\s元/, '$1'));
          planDataContent.push(
            <div className="program-details__table-tr" key={`footer${footerIndex}`}>
              <div className="program-details__table-td">{footerContent.TITLE}</div>
              <div className="program-details__table-td" style={{ color: '#FE3208' }}>{footerContent.TOTAL.replace(/(.*\s)([\d]{0,})(\s元)/, `$1${total}$3`)}</div>
            </div>
          );
        });
      }

      // #endregion

      // #region 建立職業類別下拉選單

      let occupationIdOpt: JSX.Element[];
      if (this.props.occupations && this.props.occupations.length > 0) {
        occupationIdOpt = _.map(this.props.occupations, (occupation: Occupation, index: number) => {
          return <option key={index} value={occupation.OCCUPATION_DOMAIN_ID}>{occupation.OCCUPATION_NAME}</option>;
        });
      }

      let occupationContents: JSX.Element[];
      if (this.state.occupationId && (this.state.occupationId === OccupationIdType.Special || this.state.occupationId === OccupationIdType.Normal)) {
        const occupation = _.find(this.props.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === this.state.occupationId);

        if (occupation) {
          occupationContents = _.map(occupation.OCCUPATION, (content: OccupationContent, index: number) => {
            return <option key={index} value={content.OCCUPATION_ID}>{content.OCCUPATION_NAME}</option>;
          });
        }
      }

      // #endregion
      return (
        <div className="insure-process-fill">
          <Formik
            innerRef={this.formikRef}
            initialValues={initialValues}
            validationSchema={this.validationSchema}
            onSubmit={this.handleOnSubmit}
            enableReinitialize
          >
            {({ values, errors, touched, setFieldValue, setFieldTouched, handleChange, handleBlur }) => (
              <Form>
                {/* <p>{JSON.stringify(values, null, 2)}</p> */}
                <div className="insure-process-fill__content">
                  <div className="travel-info">
                    <div className="travel-info__title">旅遊資訊</div>
                    <div className="travel-info__content">
                      <div className="program-info">
                        <div className="program-info__container">
                          <div className="program-info__header">
                            <span>方案</span>
                            <div className="program-info__header-row">
                              <div className="program-info__block">
                                <span>{this.state.planData?.HEADER?.TITLE}</span>
                              </div>
                              <button
                                type="button"
                                className={'element__icon-button' + (programDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                                onClick={this.handleProgramDetailsToggle}
                                style={{ display: 'none' }}
                              >
                                {programDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                              </button>
                            </div>
                          </div>
                          <div className="program-info__details" style={{ height: programDetailsElemHeight }}>
                            <div className="program-details" ref={this.programDetailsRef}>
                              <div className="program-details__table">
                                {planDataContent}
                              </div>
                            </div>
                          </div>
                          <div className="program-list">
                            <div className="program-list__item">
                              <span>保險期間</span>
                              {handleGetInsperiod()}
                            </div>
                            <div className="program-list__item">
                              <span>旅遊/活動地點</span>
                              <p>{handleTravelInfoFormat(handleGetTravelInfo() as string)}</p>
                            </div>
                            <div className="program-list__item">
                              <span>15歲以上試算總保費</span>
                              {
                                values.INSUREDS.filter((item: any) => item.INSURED_AMT).length === 0 ? (
                                  <span>({this.props.tempCalc.evalReq?.OVER15_COUNT} 位)</span>
                                ) : (
                                  <span>({values.INSUREDS.filter(item => item.INSURED_AMT && item.INSURED_IS_UNDER15 === false).length} 位)</span>
                                )
                              }
                              {
                                this.handleGetSubTotalO15() + this.handleGetSubTotalU15() === 0 ? (
                                  <p>{this.props.tempCalc.planData?.SUBTOTAL_O15[0].FIELD}</p>
                                ) : <p>NT$ {this.handleGetSubTotalO15()} 元</p>
                              }
                            </div>
                            {this.props.tempCalc.planData?.PROD_ID !== TravelPlanType.NTAG &&
                              <div className="program-list__item">
                                <span>15歲以下試算總保費</span>
                                {
                                  values.INSUREDS.filter((item: any) => item.INSURED_AMT).length === 0 ? (
                                    <span>({this.props.tempCalc.evalReq?.UNDER15_COUNT} 位)</span>
                                  ) : (
                                    <span>({values.INSUREDS.filter(item => item.INSURED_AMT && item.INSURED_IS_UNDER15 === true).length} 位)</span>
                                  )
                                }
                                {
                                  this.handleGetSubTotalO15() + this.handleGetSubTotalU15() === 0 ? (
                                    <p>{this.props.tempCalc.planData?.SUBTOTAL_U15[0].FIELD}</p>
                                  ) : <p>NT$ {this.handleGetSubTotalU15()} 元</p>
                                }
                              </div>}
                            <div className="program-list__item">
                              <span>保費合計</span>
                              {
                                this.handleGetSubTotalO15() + this.handleGetSubTotalU15() === 0 ? (
                                  <p>{this.props.tempCalc.planData?.FOOTER[0].TOTAL}</p>
                                ) : <p>NT$ {this.handleGetSubTotalO15() + this.handleGetSubTotalU15()} 元</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={programSummaryClasses.join(' ')}>
                        <div className="template-content">
                          {
                            /**
                                                      <div className="program-info__header">
                                                        <span>方案</span>
                                                        <div className="program-info__header-row">
                                                          <div className="program-info__block">
                                                            <span>{this.state.planData?.HEADER?.TITLE}</span>
                                                          </div>
                                                          <button
                                                            type="button"
                                                            className={'element__icon-button' + (programSummaryDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                                                            onClick={this.handleProgramSummaryDetailsToggle}
                                                          >
                                                            {programSummaryDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    */
                          }
                          <div className="program-summary__details" style={{ height: programSummaryDetailsElemHeight }}>
                            <div className="program-summary__details-wrap">
                              <div className="program-details">
                                <div className="program-details__table">
                                  {planDataContent}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="program-list">
                            <div className="program-list__item">
                              <span>保險期間</span>
                              {handleGetInsperiod()}
                            </div>
                            <div className="program-list__item">
                              <span>旅遊/活動地點</span>
                              <p>{handleTravelInfoFormat(handleGetTravelInfo() as string)}</p>
                            </div>
                            {
                              this.handleGetSubTotalO15() + this.handleGetSubTotalU15() === 0 ? (
                                <>
                                  <div className="program-list__item">
                                    <span>15歲以上試算總保費</span>
                                    <span>({this.props.tempCalc.evalReq?.OVER15_COUNT} 位)</span>
                                    <p>{this.props.tempCalc.planData?.SUBTOTAL_O15[0].FIELD}</p>
                                  </div>
                                  {this.props.tempCalc.planData?.PROD_ID !== TravelPlanType.NTAG &&
                                    <div className="program-list__item">
                                      <span>15歲以下試算總保費</span>
                                      <span>({this.props.tempCalc.evalReq?.UNDER15_COUNT} 位)</span>
                                      <p>{this.props.tempCalc.planData?.SUBTOTAL_U15[0].FIELD}</p>
                                    </div>}
                                  <div className="program-list__item">
                                    <span>保費合計</span>
                                    <p>{this.props.tempCalc.planData?.FOOTER[0].TOTAL}</p>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="program-list__item">
                                    <span>15歲以上試算總保費</span>
                                    <span>({values.INSUREDS.filter(item => item.INSURED_AMT && item.INSURED_IS_UNDER15 === false).length} 位)</span>
                                    <p>NT$ {this.handleGetSubTotalO15()} 元</p>
                                  </div>
                                  {this.props.tempCalc.planData?.PROD_ID !== TravelPlanType.NTAG &&
                                    <div className="program-list__item">
                                      <span>15歲以下試算總保費</span>
                                      <span>({values.INSUREDS.filter(item => item.INSURED_AMT && item.INSURED_IS_UNDER15 === true).length} 位)</span>
                                      <p>NT$ {this.handleGetSubTotalU15()} 元</p>
                                    </div>}
                                  <div className="program-list__item">
                                    <span>保費合計</span>
                                    <p>NT$ {this.handleGetSubTotalO15() + this.handleGetSubTotalU15()} 元</p>
                                  </div>
                                </>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="policyholder-info" ref={this.policyholderInfoRef}>
                    <div className="policyholder-info__title">
                      <span>要保人資料</span>
                      <p>*完成投保後同步更新會員資料</p>
                    </div>
                    <div className="policyholder-info__content">
                      <div className="policyholder-info__form">
                        <div className="element__form-table">
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.NATIONALITY_TYPE && touched.NATIONALITY_TYPE ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">證件類別*</div>
                                <div className="element__form-group-content" data-fieldname="NATIONALITY_TYPE" tabIndex={1} style={{ outline: 'none' }}>
                                  {
                                    this.state.nationalitySysOpts.length > 0 && _.map(this.state.nationalitySysOpts, (sysOpt: SysOption, index: number) => {
                                      return (
                                        <div className="element__radio-group" key={sysOpt.PARAM_ID}>
                                          <label htmlFor={`national-radio${index}`}>
                                            <div className="element__radio">
                                              <Field
                                                type="radio"
                                                disabled={this.state.hasMemberId}
                                                name="NATIONALITY_TYPE"
                                                id={`national-radio${index}`}
                                                value={sysOpt.PARAM_VALUE}
                                                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                  if (values.NATIONALITY_TYPE !== e.currentTarget.value) {
                                                    this.onValidID(values.MEMBER_ID, e.currentTarget.value);
                                                  }
                                                  this.setState({
                                                    prodIdError: this.handleCheckProdId(e.currentTarget.value)
                                                  });
                                                }}
                                              />
                                              <div className="element__radio-btn" />
                                            </div>
                                            <span>{sysOpt.PARAM_TEXT}</span>
                                          </label>
                                        </div>
                                      );
                                    })
                                  }
                                </div>
                                <div className="element__error-message">
                                  <ErrorMessage name="NATIONALITY_TYPE" />
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-td">
                              <div className="element__form-group">
                                <div className="element__form-group-title">投保對象*</div>
                                <Field as="select" name="INSURE_SUBJECT" className="element__select" disabled>
                                  {
                                    this.state.insureSubject
                                      ? <option value={this.state.insureSubject.PARAM_VALUE}>{this.state.insureSubject.PARAM_TEXT}</option>
                                      : <option value="">{selectOptDefaultText}</option>
                                  }
                                </Field>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.MEMBER_ID && touched.MEMBER_ID ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">{values.NATIONALITY_TYPE === 'N' ? '身分證字號' : values.NATIONALITY_TYPE === 'F' ? '居留證號' : '身分證字號'}*</div>
                                {this.state.hidePolicyID
                                  ? <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.MEMBER_ID, 5)} disabled readOnly />
                                  : (
                                    <Field
                                      type="text"
                                      disabled={this.state.hasMemberId}
                                      name="MEMBER_ID"
                                      data-fieldname="MEMBER_ID"
                                      tabIndex={2}
                                      maxLength={10}
                                      className="element__input"
                                      autoComplete="off"
                                      placeholder="請輸入身分證字號 / 居留證號"
                                      validate={() => this.state.memberIdErrMsg}
                                      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        handleBlur(e);
                                        this.handleSetInsuredVal('INSURED_ID', e.currentTarget.value, values);
                                      }}
                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                        this.onValidID(val, values.NATIONALITY_TYPE);
                                        if (e && e.currentTarget.value && e.currentTarget.value.length === 10) {
                                          this.handleSetSelfCalcInfoByIdAndBirthday(val, values.BIRTHDAY, values, true);
                                        }
                                        setFieldTouched('MEMBER_ID', true);
                                        handleChange('MEMBER_ID')(e);
                                        setFieldValue('MEMBER_ID', val);
                                      }}
                                    />
                                  )}
                                <button type="button" className="element__view-btn" onClick={this.handleViewToggle}>
                                  {this.state.hidePolicyID ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                                </button>
                                <div className="element__error-message">
                                  <ErrorMessage name="MEMBER_ID" />
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.NAME && touched.NAME ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">要保人姓名*</div>
                                <Field
                                  type="text"
                                  name="NAME"
                                  data-fieldname="NAME"
                                  tabIndex={3}
                                  autoComplete="off"
                                  maxLength={200}
                                  className="element__input"
                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleBlur(e);
                                    this.handleSetInsuredVal('INSURED_NAME', e.currentTarget.value, values);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="NAME" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.BIRTHDAY && touched.BIRTHDAY ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">生日* <span className="ant-picker-exam-info">範例： 20200101</span></div>
                                <div className="element__form-group-content">
                                  <DatePicker
                                    name="BIRTHDAY"
                                    data-fieldname="BIRTHDAY"
                                    tabIndex={4}
                                    className="element__input"
                                    format="YYYYMMDD"
                                    showToday={false}
                                    validate={() => this.state.birthdayErrMsg}
                                    // defaultPickerValue={this.validBirthDay}
                                    disabledDate={(current: any) => {
                                      // 被保人生日
                                      return current && (current > moment().add(-1, 'days') || current < moment('1911/01/01'));
                                      // return currentDate && (currentDate > moment(new Date()).add(-1, 'days') || currentDate < moment('1911/01/01'));
                                    }}
                                    onChange={async (e: any) => {
                                      if (e) {
                                        const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
                                        const nzTime = commonService.normalizeTime(e.format('YYYY-MM-DD'), sysTime);
                                        const selfIndex = this.handleGetSelfIndex(values);

                                        setFieldValue('BIRTHDAY', nzTime);
                                        await this.handleSetInsuredVal('INSURED_BIRTHDAY', nzTime, values);
                                        await this.handleValidBirthday(nzTime, values);

                                        if (selfIndex !== -1) {
                                          await this.handleInsuredBirthdayChange(selfIndex, nzTime, values.INSUREDS, setFieldValue);
                                        }
                                      }
                                    }}
                                  />
                                </div>
                                <div className="element__error-message">
                                  <ErrorMessage name="BIRTHDAY" />
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.MOBILE && touched.MOBILE ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">手機號碼*</div>
                                <Field
                                  component={InputWithRegex}
                                  name="MOBILE"
                                  data-fieldname="MOBILE"
                                  tabIndex={5}
                                  autoComplete="off"
                                  className="element__input"
                                  placeholder="0910123456"
                                  maxLength={10}
                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleBlur(e);
                                    this.handleSetInsuredVal('INSURED_MOBILE', e.currentTarget.value, values);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="MOBILE" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + (errors.EMAIL_ADDR && touched.EMAIL_ADDR ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">電子信箱*</div>
                                <AutoComplete
                                  name="EMAIL_ADDR"
                                  data-fieldname="EMAIL_ADDR"
                                  tabIndex={6}
                                  style={{ outline: 'none' }}
                                  id="email"
                                  className="element__antd-input"
                                  placeholder="請輸入電子信箱"
                                  options={this.handleGetDomainSource(values.EMAIL_ADDR)}
                                  onBlur={(e: any) => {
                                    handleBlur(e);
                                    this.handleSetInsuredVal('INSURED_EMAIL_ADDR', e.target.value, values);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="EMAIL_ADDR" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + ((errors.POST_CODE && touched.POST_CODE) || (errors.ADDRESS && touched.ADDRESS) || (errors.CITY_ID && touched.CITY_ID) || (errors.AREA_ID && touched.AREA_ID) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">通訊地址*</div>
                                <div className="element__form-group-content" style={{ flexWrap: 'wrap' }}>
                                  <AddressComponent
                                    postCodeName="POST_CODE"
                                    postCodeId="postal-code-input"
                                    postCodeIdTabIndex={7}
                                    cityIdName="CITY_ID"
                                    cityId="county-select"
                                    cityIdVal={values.CITY_ID}
                                    cityIdText="CITY_NAME"
                                    cityIdTabIndex={8}
                                    areaIdName="AREA_ID"
                                    areaId="district-select"
                                    areaIdTabIndex={9}
                                    quickPick
                                    areaNameVal={values.AREA_NAME}
                                    areaIdText="AREA_NAME"
                                    addressName="ADDRESS"
                                    addressId="address-input"
                                    addressIdTabIndex={10}
                                    postcodes={this.props.postcodes}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                  />
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.POST_CODE
                                      ? <ErrorMessage name="POST_CODE" />
                                      : errors.CITY_ID
                                        ? <ErrorMessage name="CITY_ID" />
                                        : errors.AREA_ID
                                          ? <ErrorMessage name="AREA_ID" />
                                          : errors.ADDRESS
                                            ? <ErrorMessage name="ADDRESS" />
                                            : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              <div className={'element__form-group' + ((errors.OCCUPATION_DOMAIN_ID && touched.OCCUPATION_DOMAIN_ID) || (errors.OCCUPATION_ID && touched.OCCUPATION_ID) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">職業類別*</div>
                                <div className="element__form-group-content">
                                  <Field
                                    as="select"
                                    name="OCCUPATION_DOMAIN_ID"
                                    data-fieldname="OCCUPATION_DOMAIN_ID"
                                    tabIndex={11}
                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                      this.handleOccupationIdChange(e, setFieldValue);
                                      handleChange('OCCUPATION_DOMAIN_ID')(e);
                                    }}
                                    id="career-category-select"
                                    className="element__select"
                                  >
                                    <option value="">{selectOptDefaultText}</option>
                                    {occupationIdOpt}
                                  </Field>
                                  <Field
                                    as="select"
                                    name="OCCUPATION_ID"
                                    data-fieldname="OCCUPATION_ID"
                                    tabIndex={12}
                                    id="career-items-select"
                                    className="element__select"
                                    disabled={this.state.occupationId !== OccupationIdType.Special}
                                    onChange={(e: any) => {
                                      commonService.setSelectOptName(setFieldValue, 'OCCUPATION_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                      handleChange('OCCUPATION_ID')(e);
                                    }}
                                  >
                                    <option value="">{selectOptDefaultText}</option>
                                    {occupationContents}
                                  </Field>
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.OCCUPATION_DOMAIN_ID
                                      ? <ErrorMessage name="OCCUPATION_DOMAIN_ID" />
                                      : errors.OCCUPATION_ID
                                        ? <ErrorMessage name="OCCUPATION_ID" />
                                        : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="statement">
                    <div className="statement__title">要保人聲明事項</div>
                    <div className="statement__content">
                      <div className="statement__form" data-fieldname="KYCINFOS" tabIndex={13} style={{ outline: 'none' }}>
                        <FieldArray name="KYCINFOS">
                          {
                            () => (
                              <>
                                {
                                  this.props.kycClaims && this.props.kycClaims.length > 0 && values.KYCINFOS ? (
                                    _.map(this.props.kycClaims, (kycClaim: KycClaim, claimIndex: number) => {
                                      return (
                                        <div
                                          className={'element__form-group' + (
                                            (getIn(errors, `KYCINFOS[${claimIndex}].KYC_ANSWER`) && getIn(touched, `KYCINFOS[${claimIndex}].KYC_ANSWER`)) ||
                                            (getIn(errors, `KYCINFOS[${claimIndex}].KYC_OTHER`) && getIn(touched, `KYCINFOS[${claimIndex}].KYC_OTHER`))
                                              ? ' element__form-group--invalid'
                                              : '')}
                                          key={kycClaim.KYC_ID}
                                        >
                                          <div className="element__form-group-title">{`${kycClaim.KYC_SUBJECT}`}</div>
                                          <div className="element__form-group-content">
                                            {
                                              _.map(kycClaim.KYC_OPTIONS, (kycOpt: KycOptionContent, kycOptIndex: number) => {
                                                return (
                                                  <div className={'element__radio-group' + (kycOpt.KEY === '99' ? ' element__radio-group-other' : '')} key={kycOptIndex}>
                                                    <label htmlFor={`KYCINFOS${claimIndex}${kycOpt.KEY}${kycOptIndex}`}>
                                                      <div className="element__radio">
                                                        <Field
                                                          disabled={this.state.isAgeLimit}
                                                          type="radio" name={`KYCINFOS[${claimIndex}].KYC_ANSWER`}
                                                          id={`KYCINFOS${claimIndex}${kycOpt.KEY}${kycOptIndex}`}
                                                          value={kycOpt.KEY}
                                                          onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            if (e.currentTarget.value !== '99' && getIn(values, `KYCINFOS[${claimIndex}].KYC_OTHER`)) {
                                                              setFieldValue(`KYCINFOS[${claimIndex}].KYC_OTHER`, '', false);
                                                            }
                                                            setFieldValue(`KYCINFOS[${claimIndex}].KYC_ANSWER_TEXT`, kycOpt.VAL, false);
                                                          }}
                                                        />
                                                        <div className="element__radio-btn" />
                                                      </div>
                                                      <span>{kycOpt.VAL}</span>
                                                    </label>
                                                    {
                                                      kycOpt.KEY === '99'
                                                        ? <Field
                                                          maxLength={50}
                                                          autoComplete="off"
                                                          disabled={this.state.isAgeLimit || getIn(values, `KYCINFOS[${claimIndex}].KYC_ANSWER`) !== '99'}
                                                          type="text"
                                                          name={`KYCINFOS[${claimIndex}].KYC_OTHER`}
                                                          id={`KYCINFOS${claimIndex}-input`}
                                                          className="element__input"
                                                          placeholder={
                                                            claimIndex === 0 ? '請輸入被保險人關係'
                                                              : claimIndex === 4 ? '請輸入投保目的及需求'
                                                                : claimIndex === 5 ? '請輸入資金來源'
                                                                  : ''
                                                          }
                                                          // eslint-disable-next-line react/jsx-closing-bracket-location
                                                        />
                                                        : null
                                                    }
                                                  </div>
                                                );
                                              })
                                            }
                                          </div>
                                          <div className="element__error-message">
                                            {
                                              getIn(errors, `KYCINFOS[${claimIndex}].KYC_ANSWER`)
                                                ? <ErrorMessage name={`KYCINFOS[${claimIndex}].KYC_ANSWER`} />
                                                : getIn(errors, `KYCINFOS[${claimIndex}].KYC_OTHER`)
                                                  ? <ErrorMessage name={`KYCINFOS[${claimIndex}].KYC_OTHER`} />
                                                  : ''
                                            }
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : null
                                }
                              </>
                            )
                          }
                        </FieldArray>
                      </div>
                    </div>
                  </div>
                  <div className="insured-info" data-fieldname="INSUREDS" tabIndex={14} style={{ outline: 'none' }}>
                    <div className="insured-info__title">
                      <span>被保險人資料</span>
                      <p className="fw-bold fs-18">*受益人：本網路投保業務之意外身故保險金受益人為法定繼承人</p>
                    </div>
                    <div className="insured-info__content">
                      <FieldArray name="INSUREDS">
                        {
                          ({ push, remove }) => (
                            <>
                              {
                                values.INSUREDS ? (
                                  _.map(values.INSUREDS, (insured: InsuredState, index: number) => {
                                    return (
                                      <div className="insured-info__item" key={index} ref={index === values.INSUREDS.length - 1 ? this.lastInsuredRef : null}>
                                        <div className="insured-info__form">
                                          {
                                            index !== 0 ? (
                                              <button type="button" className="insured-info__item-delete-btn" onClick={() => this.handleDeleteInsured(index, values, remove)} />
                                            ) : null
                                          }
                                          <div className="element__form-table">
                                            <div className="element__form-table-tr">
                                              <div className="element__form-table-td">
                                                <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_RELATION`) && getIn(touched, `INSUREDS[${index}].INSURED_RELATION`) ? ' element__form-group--invalid' : '')}>
                                                  <div className="element__form-group-title">被保險人為要保人之*</div>
                                                  <Field
                                                    as="select"
                                                    disabled={this.state.isAgeLimit}
                                                    name={`INSUREDS[${index}].INSURED_RELATION`}
                                                    value={insured.INSURED_RELATION}
                                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                      handleChange(e);
                                                      this.handleInsuredRelationChange(e.currentTarget.value, index, values);
                                                    }}
                                                    className="element__select"
                                                  >
                                                    <option value="">{selectOptDefaultText}</option>
                                                    {this.handleGetRelationOpts()}
                                                  </Field>
                                                  <div className="element__error-message">
                                                    <ErrorMessage name={`INSUREDS[${index}].INSURED_RELATION`} />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="element__form-table-td">
                                                <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_NAME`) && getIn(touched, `INSUREDS[${index}].INSURED_NAME`) ? ' element__form-group--invalid' : '')}>
                                                  <div className="element__form-group-title">第{index + 1}位被保險人姓名*</div>
                                                  <Field
                                                    type="text"
                                                    autoComplete="off"
                                                    disabled={this.state.isAgeLimit}
                                                    maxLength={200}
                                                    name={`INSUREDS[${index}].INSURED_NAME`}
                                                    className="element__input"
                                                  />
                                                  <div className="element__error-message">
                                                    <ErrorMessage name={`INSUREDS[${index}].INSURED_NAME`} />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-tr">
                                              <div className="element__form-table-td">
                                                <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_ID`) ? ' element__form-group--invalid' : '')}>
                                                  <div className="element__form-group-title">身分證字號 (居留證號碼)*</div>
                                                  <Field
                                                    type="text"
                                                    autoComplete="off"
                                                    disabled={this.state.isAgeLimit}
                                                    onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                      handleBlur(e);
                                                      setFieldValue(`INSUREDS[${index}].INSURED_ID_VALID`, true);
                                                    }}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                      handleChange(e);
                                                      const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                                      setFieldValue(`INSUREDS[${index}].INSURED_ID`, val);
                                                      if (val && val.length === 10) {
                                                        if (val !== values.MEMBER_ID) this.handleValidInsuredId(index, val, values.INSUREDS, setFieldValue);
                                                        if (val === values.MEMBER_ID) this.handleIsSelf(setFieldValue, index, values, moment(insured.INSURED_BIRTHDAY));
                                                      }
                                                    }}
                                                    maxLength={10}
                                                    name={`INSUREDS[${index}].INSURED_ID`}
                                                    className="element__input"
                                                    validate={async (val: any) => {
                                                      if (val && val.length === 10 && values.INSUREDS[index] && values.INSUREDS[index].INSURED_ID_VALID) {
                                                        const errorVal = await memberProfileService.validMemberId(val).then((res: any) => {
                                                          return res.ID;
                                                        });

                                                        if (!errorVal) {
                                                          setFieldValue(`INSUREDS[${index}].INSURED_ID_VALID`, false);
                                                        }
                                                        return errorVal;
                                                      }
                                                    }}
                                                  />
                                                  <div className="element__error-message">
                                                    <ErrorMessage name={`INSUREDS[${index}].INSURED_ID`} />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="element__form-table-td">
                                                <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_BIRTHDAY`) && getIn(touched, `INSUREDS[${index}].INSURED_BIRTHDAY`) ? ' element__form-group--invalid' : '')}>
                                                  <div className="element__form-group-title">生日*<span className="ant-picker-exam-info">範例： 20200101</span></div>
                                                  <div className="element__form-group-content">
                                                    <DatePicker
                                                      name={`INSUREDS[${index}].INSURED_BIRTHDAY`}
                                                      className="element__input"
                                                      format="YYYYMMDD"
                                                      disabled={this.state.isAgeLimit}
                                                      validate={() => this.state.insuredsBirthdayErrMsg}
                                                      showToday={false}
                                                      // defaultPickerValue={this.validBirthDay}
                                                      disabledDate={(current: any) => {
                                                      // 被保人生日
                                                        return current && (current > moment().add(-1, 'days') || current < moment('1911/01/01'));
                                                      // return currentDate && (currentDate > moment(new Date()).add(-1, 'days') || currentDate < moment('1911/01/01'));
                                                      }}
                                                      onChange={async (e: any) => {
                                                      // const insureds = this.formikRef.current.values.INSUREDS;
                                                        if (e) {
                                                          const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
                                                          const nzTime = commonService.normalizeTime(e.format('YYYY-MM-DD'), sysTime);
                                                          setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, nzTime);
                                                          await this.handleInsuredBirthdayChange(index, nzTime, values.INSUREDS, setFieldValue);
                                                          this.handleCheckInsuredBirthdayThroughInsuredRelation(nzTime, index);
                                                          this.handleCheckPlanSingleInsuredBirthday(nzTime, index);
                                                        }
                                                      // insureds.forEach((item: any, index: number) => {
                                                      //   if (item.INSURED_IS_UNDER15 === isUnder15) setFieldValue(`INSUREDS[${index}].INSURED_AMT`, mfuneral);
                                                      // });
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="element__error-message">
                                                    <ErrorMessage name={`INSUREDS[${index}].INSURED_BIRTHDAY`} className="element__error-message" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-tr">
                                              <div className="element__form-table-td" style={{ flexWrap: 'wrap' }}>
                                                <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_AMT`) && getIn(touched, `INSUREDS[${index}].INSURED_AMT`) ? ' element__form-group--invalid' : '')}>
                                                  <div className="element__form-group-title">身故失能保額*</div>
                                                  <Field
                                                    as="select"
                                                    disabled={this.state.isAgeLimit || insured.INSURED_BIRTHDAY_ERROR || insured.INSURED_ID_ERROR || handleCheckInsuredAmt(index)}
                                                    name={`INSUREDS[${index}].INSURED_AMT`}
                                                    className="element__select"
                                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                      // setFieldValue(`INSUREDS[${index}].INSURED_AMT`, e.currentTarget.value);
                                                      const isUnder15 = values.INSUREDS[index].INSURED_IS_UNDER15;
                                                      if (!isUnder15 || (isUnder15 && values.INSUREDS[index].INSURED_MFUNERAL !== 0)) {
                                                        this.handleSetMedicalAmt(index, e.currentTarget.value, e.currentTarget.selectedOptions.item(0)?.text ?? '', values.INSUREDS);
                                                      }
                                                    }}
                                                  >
                                                    <option value="">{selectOptDefaultText}</option>
                                                    {
                                                      this.handleCreateInsuredAmtOpt(insured.INSURED_AMT_OPTS)
                                                    }
                                                  </Field>
                                                </div>
                                                <div className="element__form-group">
                                                  <div className="element__form-group-title">實支實付醫療</div>
                                                  <Field type="text" disabled name={`INSUREDS[${index}].INSURED_MEDICAL`} className="element__input" />
                                                </div>
                                                <p className="element__red-text">{this.state.notices[index]?.map((text, i) => <p key={i}>{text}</p>)}</p>
                                              </div>
                                              <div className="element__form-table-td">
                                                <div className="insured-info__fee">
                                                  {
                                                    insured.INSURED_CALC ? `NT$ ${commonService.thousandFormat(`${insured.INSURED_CALC}`)} 元` : ''
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                            {
                                              values.INSUREDS[index].INSURED_IS_UNDER15 && values.INSUREDS[index].INSURED_BIRTHDAY && this.state.prodId !== TravelPlanType.NTAG &&
                                                <div className="element__form-table-tr">
                                                  <div className="element__form-table-td">
                                                    <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_MFUNERAL`) && getIn(touched, `INSUREDS[${index}].INSURED_MFUNERAL`) ? ' element__form-group--invalid' : '')}>
                                                      <div className="element__form-group-title">喪葬費用*</div>
                                                      <Field
                                                        as="select"
                                                        name={`INSUREDS[${index}].INSURED_MFUNERAL`}
                                                        id="under-15-years-old-accident-select"
                                                        className="element__select"
                                                        disabled={handleCheckInsuredAmtOpts(index) || insured.INSURED_BIRTHDAY_ERROR}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                          const mfuneral = e.currentTarget.value;
                                                          const insureds = this.formikRef.current.values.INSUREDS;
                                                          const isUnder15 = values.INSUREDS[index].INSURED_IS_UNDER15;
                                                          insureds.forEach((item: any, index: number) => {
                                                            if (item.INSURED_IS_UNDER15 === isUnder15) setFieldValue(`INSUREDS[${index}].INSURED_MFUNERAL`, mfuneral);
                                                          });
                                                          this.handleSetMfuneral(index, mfuneral, values.INSUREDS);
                                                        }}
                                                      >
                                                        <option value={0}>{selectOptDefaultText}</option>
                                                        {
                                                          this.handleCreateInsuredFuneralOpt(insured.INSURED_AMT_OPTS)
                                                        }
                                                      </Field>
                                                      <div className="element__error-message">
                                                        <ErrorMessage name={`INSUREDS[${index}].INSURED_MFUNERAL`} className="element__error-message" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : null
                              }
                              {
                                this.props.tempCalc.tempCalcFormVal?.INS_COUNT !== InsCount.One && (
                                  <div className="insured-info__controls">
                                    <button
                                      type="button"
                                      disabled={this.state.isAgeLimit ||
                                                                            _.some(values.INSUREDS, (insured: InsuredState) => insured.INSURED_BIRTHDAY_ERROR || insured.INSURED_ID_ERROR)}
                                      className="element__icon-button element__icon-button--add"
                                      onClick={() => this.handleAddInsured(values, push)}
                                    >
                                      新增被保險人
                                    </button>
                                  </div>
                                )
                              }
                            </>
                          )
                        }
                      </FieldArray>
                    </div>
                  </div>
                  <div className="delivery">
                    <div className="delivery__title">保單寄送方式</div>
                    <div className="delivery__content">
                      <div className={'element__form-group' + (errors.DELIVERY && touched.DELIVERY ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-content">
                          {
                            this.state.policyDeliverySysOpts && this.state.policyDeliverySysOpts.length > 0 && _.map(this.state.policyDeliverySysOpts, (sysopt: SysOption, index: number) => {
                              return (
                                <div className="element__radio-group" key={index}>
                                  <label htmlFor={`electronic-delivery-radio${index}`}>
                                    <div className="element__radio">
                                      <Field
                                        type="radio"
                                        disabled={
                                          this.state.isAgeLimit ||
                                                                                _.some(values.INSUREDS, (insured: InsuredState) => insured.INSURED_BIRTHDAY_ERROR || insured.INSURED_ID_ERROR)
                                        }
                                        name="DELIVERY"
                                        id={`electronic-delivery-radio${index}`}
                                        value={sysopt.PARAM_VALUE}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>{sysopt.PARAM_TEXT}</span>
                                  </label>
                                  {
                                    sysopt.PARAM_VALUE === PolicyDelivery.Electric ? <a className="element__link" href={RouterSettings.MemberCenter.ElectronicPolicy} rel="noopener noreferrer" target="_blank">(說明)</a> : null
                                  }
                                </div>
                              );
                            })
                          }
                          {
                            this.state.policyDeliverySysOpts.length === 2 &&
                              <>
                                <p>{commonService.getCodeMsg(this.props.UICode, CodeId.U019)}</p>
                                <p>{commonService.getCodeMsg(this.props.UICode, CodeId.U052)}</p>
                              </>
                          }
                          {(this.state.policyDeliverySysOpts.length === 1 && this.state.policyDeliverySysOpts[0].PARAM_VALUE === PolicyDelivery.Electric)
                            ? <p>{commonService.getCodeMsg(this.props.UICode, CodeId.U019)}</p>
                            : (this.state.policyDeliverySysOpts.length === 1)
                              ? <p>{commonService.getCodeMsg(this.props.UICode, CodeId.U052)}</p>
                              : null}
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="DELIVERY" className="element__error-message" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="insure-process-fill__controls">
                  <button type="button" className="element__button element__button--red-border" onClick={() => this.handleGoBack()}>返回上一頁</button>
                  <button
                    type="submit"
                    disabled={this.state.isAgeLimit ||
                      _.some(values.INSUREDS, (insured: InsuredState) => insured.INSURED_BIRTHDAY_ERROR || insured.INSURED_ID_ERROR) ||
                      this.state.prodIdError}
                    className="element__button element__button--red"
                    // onClick={this.handleSubmitButtonOnClick}
                  >
                    下一步
                  </button>
                </div>
                <FormikFocusError />
                <MemberInfoErrorModal />
              </Form>
            )}
          </Formik>
        </div>
      );
    }
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: string[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
    setInfoModalVisible: (visible: boolean, title?: string, content?: string) => dispatch(setInfoModalVisibleAction(visible, title, content)),
    setMemberInfoErrorModalVisible: (visible: boolean, title?: string, content?: string, fieldNames?: string[]) => dispatch(setMemberInfoErrorModalVisible(visible, title, content, fieldNames))
  };
};

export default connect(null, mapDisatchToProps)(withRouter(InsureProcessFill2nd));
